import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ValidateServiceService } from '../services/validate-service.service';
import { Observable, of } from 'rxjs';
import { GetFeedbackMessageSuccessResponse } from '../../admin/review-pending-complete/types';
import { ApiResponse } from '../models/common.model';
import { TypeOfPageLink } from 'src/app/select-forum-modal/select-form-modal.types';

export interface LocationCondition {
  fromLat: number;
  toLat: number;
  fromLng: number;
  toLng: number;
  center: { lat: number; lng: number };
  mapWidth: number;
  mapHeight: number;
}

export interface FetchProductsOptions {
  types?: any[];
  isSubType?: boolean;
  areTypesNames?: boolean;
  page?: number;
  categoryId?: number;
  subregionId?: number[];
  subregionName?: string;
  locationCondition?: LocationCondition | null;
}

@Injectable({
  providedIn: 'root',
})
export class AuthServiceService {
  public enableLoader: boolean = false;
  baseUrl = environment.baseUrlAdmin;
  constructor(
    private http: HttpClient,
    private header: ValidateServiceService,
  ) {}

  ////////////////////////////////// Admin Sheet /////////////////////////////////////////////////
  /// ADMIN SHEETS
  public createAdminSheet(
    name: string,
    linkedActionType: string,
    linkedResourceId: number | string = null,
    otherInfos = {}
  ) {
    return this.http.post(`${this.baseUrl}createAdminSheet`, {
      name,
      linkedActionType,
      linkedResourceId,
      otherInfos
    }) as Observable<ApiResponse>;
  }

  public deleteAdminSheet(sheetId: number | string) {
    return this.http.delete(
      `${this.baseUrl}deleteAdminSheet/${sheetId}`,
    ) as Observable<ApiResponse>;
  }

  public linkSubVar(subVarId, connectedToId){
    return this.http.post(`${this.baseUrl}linkSubVar`, {subVarId, connectedToId})
  }


  public getAllAdminSheets() {
    return this.http.get(
      `${this.baseUrl}getAllAdminSheets`,
    ) as Observable<ApiResponse>;
  }

  public createAdminSheetTab(sheetId: number | string, name: string) {
    return this.http.post(`${this.baseUrl}createAdminSheetTab/${sheetId}`, {
      name,
    }) as Observable<ApiResponse>;
  }
  
  public fetchAllSubVars(){
    return this.http.get(`${this.baseUrl}fetchAllSubVars`) as Observable<ApiResponse>
  }

  public deleteAdminSheetTab(sheetTabId: number | string) {
    return this.http.delete(
      `${this.baseUrl}deleteAdminSheetTab/${sheetTabId}`,
    ) as Observable<ApiResponse>;
  }
  public changeSheetTabContent(
    sheetTabId: number | string,
    row: number,
    col: number,
    value: string,
  ) {
    return this.http.post(
      `${this.baseUrl}changeSheetTabContent/${sheetTabId}`,
      { row, col, value },
    ) as Observable<ApiResponse>;
  }

  /************************ Map Booking ********************************************/

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  //Map booking variables

  /// SUPER-GROUPS
  public getBookingVariableSuperGroupsByCategory(
    categoryId: number | string,
    isType = false,
  ) {
    return this.http.get(
      `${this.baseUrl}getBookingVariableSuperGroupsByCategory/${categoryId}?isType=${isType}`,
    ) as Observable<ApiResponse>;
  }


  public createBookingVariableSuperGroup(
    categoryId,
    title: string,
    isType: boolean,
    proximityRebateValue?: number
  ) {
    // server expects isType in body and uses your admin/category helper to resolve the category/type
    return this.http.post(
      `${this.baseUrl}createBookingVariableSuperGroup/${categoryId}`,
      { isType, categoryId, title, proximityRebateValue },
    ) as Observable<ApiResponse>;
  }

  public updateBookingVariableSuperGroup(
    superGroupId: number | string,
    title: string,
    proximityRebateValue = null,
    listView?: string
  ) {
    const payload : any =  { title, proximityRebateValue }
    if(listView){
      payload.listView = listView
    }
    return this.http.put(
      `${this.baseUrl}updateBookingVariableSuperGroup/${superGroupId}`,
      payload,
    ) as Observable<ApiResponse>;
  }

  public deleteBookingVariableSuperGroup(superGroupId: number | string) {
    return this.http.delete(
      `${this.baseUrl}deleteBookingVariableSuperGroup/${superGroupId}`,
    ) as Observable<ApiResponse>;
  }

  /// GROUPS (now created under a super-group)
  public setSubGroupImage(subGroup, image: File){
    //console.log({image})
    const payload = new FormData()
    payload.append('image', image)
    return this.http.put(`${this.baseUrl}setSubGroupImage/${subGroup}`, payload) as Observable<ApiResponse>
  }

  public cloneSubGroup(subGroup){
    return this.http.post(`${this.baseUrl}cloneSubGroup/${subGroup.id}`, {})
  }
  public createBookingVariableGroup(
    superGroupId: number | string,
    title: string,
    value = null,
    maxValue : number | null  = null,
    descr: string = '',
    descr2: string = ''
  ) {
    return this.http.post(
      `${this.baseUrl}createBookingVariableGroup/${superGroupId}`,
      { title, value, maxValue, descr, descr2 },
    ) as Observable<ApiResponse>;
  }
  public setCategoryVariableBanner(typeOrCategory,  typeOrCategoryId,  image?: File | null){ //if null means remove the image
    const payload = new FormData();
    if(image){
         payload.append('image', image)
    }
    return this.http.put(`${this.baseUrl}setCategoryVariableBanner/${typeOrCategory}/${typeOrCategoryId}`, payload) as Observable<ApiResponse>
  }

  public updateBookingVariableGroup(
    bookingVariableGroupId: number | string,
    title: string,
    value?: number | null,
    order?: number | null,
    maxValue? : number | null,
    descr?: string,
    descr2?: string
  ) {
    const payload: { title: string; value?: number | null,   order?: number | null, maxValue?: number | null,    descr?: string,  descr2?: string} = { title };
    if (value !== undefined) {
      payload.value = value;
    }
    if(order != null){
      payload.order = order
    }
    if(maxValue != null){
      payload.maxValue = maxValue
    }
    if(descr){
      payload.descr = descr
    }
    if(descr){
      payload.descr2 = descr2
    }
    return this.http.put(
      `${this.baseUrl}updateBookingVariableGroup/${bookingVariableGroupId}`,
      payload,
    ) as Observable<ApiResponse>;
  }

  public deleteBookingVariableGroup(bookingVariableGroupId: number | string) {
    return this.http.delete(
      `${this.baseUrl}deleteBookingVariableGroup/${bookingVariableGroupId}`,
    ) as Observable<ApiResponse>;
  }

  /// VARIABLES (unchanged)
  public createBookingVariable(
    bookingVariableGroupId: number | string,
    title: string,
  ) {
    return this.http.post(
      `${this.baseUrl}createBookingVariable/${bookingVariableGroupId}`,
      { title },
    ) as Observable<ApiResponse>;
  }

  public updateBookingVariable(
    bookingVariableId: number | string,
    title: string,
  ) {
    return this.http.put(
      `${this.baseUrl}updateBookingVariable/${bookingVariableId}`,
      { title },
    ) as Observable<ApiResponse>;
  }

  public deleteBookingVariable(bookingVariableId: number | string) {
    return this.http.delete(
      `${this.baseUrl}deleteBookingVariable/${bookingVariableId}`,
    ) as Observable<ApiResponse>;
  }

  /// SUB-VARIABLES
  // createBookingSubVariable requires a file (image) + other fields — use FormData
  public createBookingSubVariable(
    bookingVariableId: number | string,
    title: string,
    amount: number,
    isPercent: boolean,
    imageFile: File,
  ) {
    const fd = new FormData();
    fd.append('title', title);
    fd.append('amount', String(amount ?? 0));
    fd.append('isPercent', isPercent ? '1' : '0');
    fd.append('image', imageFile); // server expects req.files.image

    return this.http.post(
      `${this.baseUrl}createBookingSubVariable/${bookingVariableId}`,
      fd,
    ) as Observable<ApiResponse>;
  }

  public updateBookingSubVariable(
    bookingSubVariableId: number | string,
    title: string,
    amount?: number | null,
    isPercent?: boolean,
    order?: number
  ) {
    const payload: {
      title: string;
      amount?: number | null;
      isPercent?: boolean;
      order?: number
    } = { title };

    if (amount !== undefined) {
      payload.amount = amount;
    }
    if (isPercent !== undefined) {
      payload.isPercent = isPercent;
    }
    if(order){
      payload.order = order
    }

    return this.http.put(
      `${this.baseUrl}updateBookingSubVariable/${bookingSubVariableId}`,
      payload,
    ) as Observable<ApiResponse>;
  }

  public deleteBookingSubVariable(bookingSubVariableId: number | string) {
    return this.http.delete(
      `${this.baseUrl}deleteBookingSubVariable/${bookingSubVariableId}`,
    ) as Observable<ApiResponse>;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  public setTagsOfCategoryOnMap(
    categoryId: number | string,
    tags: string[],
    tagsUser: string[],
    isType: boolean,
  ) {
    return this.http.post(
      `${this.baseUrl}setTagsOfCategoryOnMap/${categoryId}`,
      { tags, tagsUser, isType },
    );
  }

  public uploadBookingImage(
    categoryId: number | string,
    image: File,
    caption: string,
    isType: boolean,
  ) {
    const payload = new FormData();
    if (image) payload.append('image', image);
    if (isType) {
      payload.append('isType', '1');
    }
    if (caption) {
      3;
      payload.append('caption', caption);
    }
    return this.http.post(
      `${this.baseUrl}uploadBookingImage/${categoryId}`,
      payload,
    );
  }

  public getMyMapQuestionResponse(isType) {
    return this.http.get(
      `${this.baseUrl}getMyMapQuestionResponse`,
    ) as Observable<ApiResponse>;
  }

  public changeCategoryBookingProperty(categoryId, key, value, isType = false) {
    return this.http.put(
      `${this.baseUrl}changeCategoryBookingProperty/${categoryId}`,
      { key, value, isType },
    ) as Observable<ApiResponse>;
  }

  public getAllMapQuestionResponse() {
    return this.http.get(
      `${this.baseUrl}getAllMapQuestionResponse`,
    ) as Observable<ApiResponse>;
  }
  public bulkSaveMapQuestionResponses(
    categoryOrTypeId,
    questionsAndResponses: { question?: string; response?: string, questionText?: string, answer?: string }[],
    typeOfStorage: 'type' | 'category',
    customUserId = null,
  ) {
    return this.http.post(
      `${this.baseUrl}bulkSaveMapQuestionResponses/${categoryOrTypeId}?typeOfStorage=${typeOfStorage}`,
      { questionsAndResponses, customUserId },
    );
  }
  // public saveMapQuestionsResponse(categoryId, question, response, isType, customUserId=null) {
  //   return this.http.post(`${this.baseUrl}saveMapQuestionsResponse/${categoryId}`, { question, response, categoryId, isType, customUserId })
  // }
  public setMapQuestions(categoryId, content, isType) {
    return this.http.put(`${this.baseUrl}setMapQuestions/${categoryId}`, {
      content,
      isType,
    });
  }

  public deleteMapAd(adId) {
    return this.http.delete(`${this.baseUrl}deleteMapAd/${adId}`);
  }
  public getAllMapAds({ filter } = { filter: null }) {
    return this.http.get(`${this.baseUrl}getAllMapAds`, {
      params: { filter },
    }) as Observable<ApiResponse>;
  }
  public createMapAd(
    { url, image, position, filter } = {
      url: null,
      image: null,
      position: 'right',
      filter: null,
    },
  ) {
    const formData = new FormData();
    formData.append('position', position);
    formData.append('filter', filter);
    if (url) {
      formData.append('url', url);
    } else if (image) {
      formData.append('image', image);
    } else {
      throw new Error('either url or image must be given');
    }

    return this.http.post(`${this.baseUrl}createMapAd`, formData);
  }

  public getSiteFollowData() {
    return this.http.get(
      `${this.baseUrl}getAllSiteFollowData`,
    ) as Observable<ApiResponse>;
  }

  public setCategoryPriority(categoryId, value: Number) {
    // console.log({arguments})
    return this.http.put(`${this.baseUrl}setCategoryPriority`, {
      categoryId,
      value,
    });
  }
  public reactToComment(replyId, type) {
    return this.http.post(`${this.baseUrl}reactToComment/${replyId}`, { type });
  }
  public getRadiusBasedProductCounts({
    categoryId = null,
    search = '',
    fromLat,
    toLat,
    fromLng,
    toLng,
    limit = null,
  }) {
    return this.http.post(`${this.baseUrl}getRadiusBasedProductCounts`, {
      categoryId,
      search,
      fromLat,
      toLat,
      fromLng,
      toLng,
      limit,
    }) as Observable<ApiResponse>;
  }

  /*******************************     Product shop  api ******************************************************/
  public deleteVariantCategory(categoryId) {
    return this.http.put(`${this.baseUrl}deleteVariantCategory`, {
      categoryId,
    });
  }
  public editVariantCategory(fd) {
    return this.http.put(`${this.baseUrl}editVariantCategory`, fd);
  }
  public editVariationOfProduct(fd) {
    return this.http.put(`${this.baseUrl}editVariationOfProduct`, fd);
  }
  public deleteVariationOfProduct(variantId) {
    return this.http.put(`${this.baseUrl}deleteVariationOfProduct`, {
      variantId,
    });
  }

  public getVariantCategories(shopId, typeOrCategory='', typeOrCategoryId=null) {
    let obs;
    if(shopId) {
       obs = this.http.get(
        `${this.baseUrl}getVariantCategories/${shopId}`,
        ) as Observable<ApiResponse>;
    }else{
      obs =  obs = this.http.get(
        `${this.baseUrl}getVariantCategories/${typeOrCategory}/${typeOrCategoryId}`,
        ) as Observable<ApiResponse>;
    }
    return obs
  }
  public createVariantCategory(shopId, imageFile, name, priority, {typeOrCategory = '', typeOrCategoryId = null} = {}) {
    const payload = new FormData();
    payload.append('image', imageFile);
    payload.append('shopId', shopId);
    payload.append('name', name);
    payload.append('priority', priority);
    
    if(typeOrCategory)
    {
      payload.append('typeOrCategory', typeOrCategory)
      payload.append('typeOrCategoryId', typeOrCategoryId)
    }

    return this.http.post(
      `${this.baseUrl}createVariantCategory`,
      payload,
    ) as Observable<ApiResponse>;
  }

  /*******************************     API related to follows/recommendation     ******************************** */
  public performFollowAction(targetId, action: 'follow' | 'unfollow') {
    return this.http.post(`${this.baseUrl}performFollowAction`, {
      targetId,
      action,
    }) as Observable<ApiResponse>;
  }
  public getPostsOfFollowedAccounts() {
    return this.http.get(
      `${this.baseUrl}getPostsOfFollowedAccounts`,
    ) as Observable<ApiResponse>;
  }

  /************************************************************************************************************** */

  public addAfforableScore(productId, answer: 'Yes' | 'No' | 'Maybe') {
    return this.http.put(`${this.baseUrl}addAfforableScore/${productId}`, {
      answer,
    });
  }
  public getMemberShopProductByName(productName) {
    return this.http.get(
      `${this.baseUrl}getMemberShopProductByName/${productName}`,
    ) as Observable<ApiResponse>;
  }
  public getLinkedProducts(productId) {
    return this.http.get(
      `${this.baseUrl}getLinkedProducts/${productId}`,
    ) as Observable<ApiResponse>;
  }
  public addVariationToProduct(payload) {
    return this.http.post(
      `${this.baseUrl}addVariationToProduct`,
      payload,
    ) as Observable<ApiResponse>;
  }
  public removeHowTo(approvedHowToId) {
    return this.http.delete(`${this.baseUrl}removeHowTo/${approvedHowToId}`);
  }
  public getApprovedHowTos(productId) {
    return this.http.get(
      `${this.baseUrl}getApprovedHowTos/${productId}`,
    ) as Observable<ApiResponse>;
  }
  public approveProductHowTo(
    productId,
    howMuch,
    howOrder,
    pointOfContact,
    reviewId,
  ) {
    return this.http.post(`${this.baseUrl}approveProductHowTo`, {
      productId,
      howMuch,
      howOrder,
      pointOfContact,
      reviewId,
    });
  }
  public setProductProperty(productId, key, value, isJSON = false) {
    const qp = new URLSearchParams();
    if (isJSON) {
      qp.set('isJSON', '1');
    }
    return this.http.put(
      `${this.baseUrl}setProductProperty/${productId}?${qp.toString()}`,
      { key, value },
    );
  }
  public givePollReward(pollId) {
    return this.http.post(`${this.baseUrl}givePollReward`, { pollId });
  }
  public toggleArchiveUserReport(body) {
    return this.http.put(`${this.baseUrl}toggleArchiveUserReport`, body);
  }
  public getAllProductBasedPromo(subRegionId) {
    return this.http.get(
      `${this.baseUrl}getAllProductBasedPromo/${subRegionId}`,
    ) as Observable<ApiResponse>;
  }
  public getAllUpgradedPromo(subRegionId) {
    return this.http.get(
      `${this.baseUrl}getAllUpgradedPromo/${subRegionId}`,
    ) as Observable<ApiResponse>;
  }
  public makeRecommendationAPromo(recommId) {
    return this.http.post(
      `${this.baseUrl}makeRecommendationAPromo/${recommId}`,
      {},
    );
  }
  public getCompanyNameSuggestions(term) {
    return this.http.get(`${this.baseUrl}getCompanyNameSuggestions/${term}`);
  }
  /****************************************  Employees **********************************************************/
  public reactToProductEmployee(employeeId) {
    return this.http.post(
      `${this.baseUrl}reactToProductEmployee/${employeeId}`,
      {},
    );
  }

  /*******************************************  Claiming reward ****************************************************/
  public getAllClaimableRewards() {
    return this.http.get(
      `${this.baseUrl}getAllClaimableRewards`,
    ) as Observable<ApiResponse>;
  }
  public claimAReward(rewardId) {
    return this.http.post(
      `${this.baseUrl}claimAReward/${rewardId}`,
      {},
    ) as Observable<ApiResponse>;
  }
  public createClaimableReward(payload) {
    return this.http.post(
      `${this.baseUrl}createClaimableReward`,
      payload,
    ) as Observable<ApiResponse>;
  }
  public editClaimableReward(rewardId, payload) {
    return this.http.put(
      `${this.baseUrl}editClaimableReward/${rewardId}`,
      payload,
    ) as Observable<ApiResponse>;
  }

  public deleteClaimableReward(rewardId) {
    return this.http.delete(
      `${this.baseUrl}deleteClaimableReward/${rewardId}`,
    ) as Observable<ApiResponse>;
  }

  public getRewardListForUser() {
    return this.http.get(
      `${this.baseUrl}getRewardListForUser`,
    ) as Observable<ApiResponse>;
  }

  public getRewardListForAllUsers() {
    return this.http.get(
      `${this.baseUrl}getRewardListForAllUsers`,
    ) as Observable<ApiResponse>;
  }
  public getAllClaimableRewardClaimsForUser() {
    return this.http.get(
      `${this.baseUrl}getAllClaimableRewardClaimsForUser`,
    ) as Observable<ApiResponse>;
  }
  public getAllClaimableRewardClaims() {
    return this.http.get(
      `${this.baseUrl}getAllClaimableRewardClaims`,
    ) as Observable<ApiResponse>;
  }

  public setClaimStatus(claimId, status: 'NOT_SENT' | 'SENT') {
    return this.http.post(`${this.baseUrl}setClaimStatus/${claimId}`, {
      status,
    });
  }

  public answerGlowQuestion(productId, wouldRecommend, whyRecommend) {
    return this.http.put(`${this.baseUrl}answerGlowQuestion/${productId}`, {
      wouldRecommend,
      whyRecommend,
    }) as Observable<ApiResponse>;
  }

  public addGlowPointsToProduct(productId, type: number, points: number) {
    return this.http.post(
      `${this.baseUrl}addGlowPointsToProduct/${productId}`,
      { type, points },
    ) as Observable<ApiResponse>;
  }

  /*******************************************  Product Shop page **************************************************/
  public setProductPageInfos(productId, payload) {
    return this.http.post(
      `${this.baseUrl}setProductPageInfos/${productId}`,
      payload,
    );
  }
  /*******************************************  Dynamic reward  ******************************************************/
  public getAssignedPointRewards() {
    return this.http.get(
      `${this.baseUrl}getAssignedPointRewards`,
    ) as Observable<ApiResponse>;
  }
  public setAssignedPointReward({ action, reward, limitPerDay = null }) {
    return this.http.post(`${this.baseUrl}setAssignedPointReward`, {
      action,
      reward,
      limitPerDay,
    }) as Observable<ApiResponse>;
  }
  public removeAssignedPointReward({ action }) {
    return this.http.delete(
      `${this.baseUrl}removeAssignedPointReward/${action}`,
    ) as Observable<ApiResponse>;
  }
  /******************************************* Member product  *******************************************************/
  public applyReviewChange(reviewId, changes) {
    return this.http.post(`${this.baseUrl}/applyReviewChange/${reviewId}`, {
      changes,
    });
  }
  public addMemberProductReview(payload) {
    return this.http.post(
      `${this.baseUrl}addMemberProductReview`,
      payload,
    ) as Observable<ApiResponse>;
  }
  public getProductReviews(search = '', page = 1) {
    const params = new URLSearchParams();
    if (search) {
      params.append('search', search);
    }
    params.append('page', page.toString());
    return this.http.get(
      `${this.baseUrl}getProductReviews?${params.toString()}`,
    ) as Observable<ApiResponse>;
  }
  public getMostReviewedOptionOfProduct(memberProductId) {
    return this.http.get(
      `${this.baseUrl}getMostReviewedOptionOfProduct/${memberProductId}`,
    ) as Observable<ApiResponse>;
  }

  public removeReview(reviewId) {
    return this.http.delete(
      `${this.baseUrl}removeReview/${reviewId}`,
    ) as Observable<ApiResponse>;
  }

  /******************************************* Search suggesion ******************************************************/
  public getSearchSuggestions(term) {
    if (!term) {
      return;
    }
    return this.http.get(
      `${this.baseUrl}getSearchSuggestions/${term}`,
    ) as Observable<ApiResponse>;
  }

  /******************************************  subregion x subcategory meta ********************************************/
  public getMetaInSubCategiryAndSubregionCombinationInfo(
    subRegionId,
    subCategoryId,
    isSubRegionName = '',
    typeId = null,
  ) {
    return this.http.get(
      `${this.baseUrl}getMetaInSubCategiryAndSubregionCombinationInfo/${subRegionId}/${subCategoryId}${typeId ? `/${typeId}` : ''}?isSubRegionName=${isSubRegionName}`,
    ) as Observable<ApiResponse>;
  }
  public updateMetaInSubCategoryAndSubregionCombinationInfo(
    payload,
    isSubRegionName = '',
  ) {
    return this.http.put(
      `${this.baseUrl}updateMetaInSubCategoryAndSubregionCombinationInfo?isSubRegionName=${isSubRegionName}`,
      payload,
    ) as Observable<ApiResponse>;
  }
  /*************** ************************** product verifeid rating  ******************************************/
  public moduloIncreaseVerifiedRating(productId): Observable<ApiResponse> {
    return this.http.put(
      `${this.baseUrl}moduloIncreaseVerifiedRating/${productId}`,
      {},
    ) as Observable<ApiResponse>;
  }
  public moduloIncreaseDollarSignRating(productId): Observable<ApiResponse> {
    return this.http.put(
      `${this.baseUrl}moduloIncreaseDollarSignRating/${productId}`,
      {},
    ) as Observable<ApiResponse>;
  }

  /*************** ************************** product popular badge ******************************************/
  public toggleProductIsPopuplarInSubRegion(
    productId,
  ): Observable<ApiResponse> {
    return this.http.put(
      `${this.baseUrl}toggleProductIsPopuplarInSubRegion/${productId}`,
      {},
    ) as Observable<ApiResponse>;
  }

  /****************************************** Community asked FAQs/answers *************************************/
  public toggleFaqApproval(faqId, type: 'faq' | 'faqAnswer') {
    return this.http.put(`${this.baseUrl}toggleFaqApproval`, { faqId, type });
  }
  public searchCommunityAskedFaqsReaction(term) {
    return this.http.get(
      `${this.baseUrl}searchCommunityAskedFaqsReaction/${term}`,
    );
  }
  public answerToCommunityFAQQuestion(
    questionId,
    text,
  ): Observable<ApiResponse> {
    return this.http.post(`${this.baseUrl}answerToCommunityFAQQuestion`, {
      questionId,
      text,
    }) as Observable<ApiResponse>;
  }
  public removeAnswerToCommunityFAQQuestion(answerId): Observable<ApiResponse> {
    return this.http.delete(
      `${this.baseUrl}removeAnswerToCommunityFAQQuestion/${answerId}`,
    ) as Observable<ApiResponse>;
  }

  public getCommunityFAQQuestionsOfCategory(
    categoryId,
  ): Observable<ApiResponse> {
    return this.http.get(
      `${this.baseUrl}getCommunityFAQQuestionsOfCategory/${categoryId}`,
    ) as Observable<ApiResponse>;
  }
  public addForumMap(payload): Observable<ApiResponse> {
    return this.http.post(
      `${this.baseUrl}/forum/map`,
      payload,
    ) as Observable<ApiResponse>;
  }
  public voteReply(payload): Observable<ApiResponse> {
    return this.http.post(
      `${this.baseUrl}/forum/vote-reply`,
      payload,
    ) as Observable<ApiResponse>;
  }
  public removeCommunityFAQQuestionFromCategory(
    questionId,
  ): Observable<ApiResponse> {
    return this.http.delete(
      `${this.baseUrl}removeCommunityFAQQuestionFromCategory/${questionId}`,
    ) as Observable<ApiResponse>;
  }

  public toggleCommunityFAQQuestionReaction(
    targetId,
    type: 'question' | 'answer',
  ): Observable<ApiResponse> {
    return this.http.patch(
      `${this.baseUrl}toggleCommunityFAQQuestionReaction`,
      { targetId, type },
    ) as Observable<ApiResponse>;
  }
  /****************************************** Linking product to pages  ***************************************/
  public toggleLinkProductToPage(
    type: TypeOfPageLink,
    pageId,
    productId,
  ): Observable<ApiResponse> {
    console.log({ arguments });
    return this.http.post(`${this.baseUrl}toggleLinkProductToPage`, {
      type,
      pageId,
      productId,
    }) as Observable<ApiResponse>;
  }
  public getPagesLinkToProduct(
    type: TypeOfPageLink,
    pageId,
  ): Observable<ApiResponse> {
    return this.http.get(
      `${this.baseUrl}getPagesLinkToProduct/${type}/${pageId}`,
    ) as Observable<ApiResponse>;
  }
  public getProuctListOfArticle(articleId): Observable<ApiResponse> {
    return this.http.get(
      `${this.baseUrl}getProuctListOfArticle/${articleId}`,
    ) as Observable<ApiResponse>;
  }

  /****************************************** Linking pages to forum pages ***************************************/
  public toggleLinkForumToPage(
    type: TypeOfPageLink,
    pageId,
    forumId,
  ): Observable<ApiResponse> {
    console.log({ arguments });
    return this.http.post(`${this.baseUrl}toggleLinkForumToPage`, {
      type,
      pageId,
      forumId,
    }) as Observable<ApiResponse>;
  }
  public getPagesLinkToForums(
    type: TypeOfPageLink,
    pageId,
  ): Observable<ApiResponse> {
    return this.http.get(
      `${this.baseUrl}getPagesLinkToForums/${type}/${pageId}`,
    ) as Observable<ApiResponse>;
  }

  /***************************************** Subregion uploads ****************************************************/

  public deleteUploadedImages(uploadId): Observable<ApiResponse> {
    return this.http.delete(
      `${this.baseUrl}deleteUploadedImages/${uploadId}`,
    ) as Observable<ApiResponse>;
  }

  public editUploadedImages(
    uploadId,
    caption,
    cropInformation,
    imageFile: File | Blob,
  ): Observable<ApiResponse> {
    const payload = new FormData();
    payload.append('caption', caption);
    payload.append('cropInformation', cropInformation);
    payload.append('imageFile', imageFile);

    return this.http.patch(
      `${this.baseUrl}editUploadedImages/${uploadId}`,
      payload,
    ) as Observable<ApiResponse>;
  }
  public getSubRegionUploadedImages(subregionId): Observable<ApiResponse> {
    return this.http.get(
      `${this.baseUrl}getSubRegionUploadedImages/${subregionId}`,
    ) as Observable<ApiResponse>;
  }
  public uploadSubregionImage(payload) {
    return this.http.post(`${this.baseUrl}uploadSubregionImage`, payload);
  }
  public toggleUploadReaction(uploadId, type) {
    return this.http.post(`${this.baseUrl}toggleUploadReaction`, {
      uploadId,
      type,
    });
  }

  /**************************************** Cached google maps geocode *******************************************/
  public setGeoCodeForProduct(productId, geoCodeString: string) {
    return this.http.post(`${this.baseUrl}setGeoCodeForProduct`, {
      productId,
      geoCodeString,
    });
  }
  public setCachedStreetname({ latLng, postalCode, subRegionId, streetName }) {
    return this.http.post(`${this.baseUrl}setCachedStreetName`, {
      latLng,
      postalCode,
      subRegionId,
      streetName,
    });
  }
  public getCachedStreetName({ latLng, postalCode }) {
    return this.http.post(`${this.baseUrl}getCachedStreetName`, {
      latLng,
      postalCode,
    });
  }

  /**************************************** Sub category keyword    **********************************************/

  public getKeywordsOfSubCategory(subCategoryId): Observable<ApiResponse> {
    return this.http.get(
      `${this.baseUrl}getKeywordsOfSubCategory/${subCategoryId}`,
    ) as Observable<ApiResponse>;
  }

  public getSubCategoriesByKeyword(keyword: string): Observable<ApiResponse> {
    return this.http.get(
      `${this.baseUrl}getSubCategoriesByKeyword/${keyword}`,
    ) as Observable<ApiResponse>;
  }
  public removeKeywordFromSubCategory(
    subCategoryId: number | string,
    keyword: string,
  ): Observable<ApiResponse> {
    return this.http.patch(`${this.baseUrl}removeKeywordFromSubCategory`, {
      subCategoryId,
      keyword,
    }) as Observable<ApiResponse>;
  }

  public addKeywordToSubCategory(
    subCategoryId: number | string,
    keyword: string,
  ): Observable<ApiResponse> {
    return this.http.patch(`${this.baseUrl}addKeywordToSubCategory`, {
      subCategoryId,
      keyword,
    }) as Observable<ApiResponse>;
  }

  /******************************************    sub types  ************************************************************* */
  public createSubType(name, parentTypeId) {
    return this.http.post(`${this.baseUrl}createSubType`, {
      name,
      parentTypeId,
    });
  }

  public getSubTypesOfType(typeId) {
    return this.http.get(`${this.baseUrl}getSubTypesOfType/${typeId}`);
  }

  public deleteSubType(typeId) {
    return this.http.delete(`${this.baseUrl}deleteSubType/${typeId}`);
  }

  /**************************************** Sub category types/FAQ  **********************************************/
  public getTypeGroupingNamesOfSubCategory(subCategoryId) {
    return this.http.get(
      `${this.baseUrl}getTypeGroupingNamesOfSubCategory/${subCategoryId}`,
    );
  }

  public fetchAllTypes(){
    return this.http.get(
      `
    ${this.baseUrl}fetchAllTypes`
    )
  }
  public getSubCategoryTypeInfo(typeId) {
    return this.http.get(`${this.baseUrl}getSubCategoryTypeInfo/${typeId}`);
  }
  public setTypeGroupingName(
    typeGroupingNumber,
    typeGroupingName,
    subCategoryId,
  ) {
    return this.http.post(`${this.baseUrl}setTypeGroupingName`, {
      typeGroupingName,
      typeGroupingNumber,
      subCategoryId,
    });
  }

  public createSubCategoryType(
    name: string,
    type: number | string,
    categoryId: number | string,
    image?: File | null,
  ) {
    if (image) {
      const formData = new FormData();
      formData.append('name', name);
      formData.append('type', `${type}`);
      formData.append('categoryId', `${categoryId}`);
      formData.append('image', image);
      return this.http.post(`${this.baseUrl}createSubCategoryType`, formData);
    }

    return this.http.post(`${this.baseUrl}createSubCategoryType`, {
      name,
      type,
      categoryId,
    });
  }

  public updateSubCategoryType(
    typeId: number | string,
    name: string,
    type: number | string,
    image?: File | null,
  ) {
    if (image !== undefined) {
      const formData = new FormData();
      formData.append('name', name);
      formData.append('type', `${type}`);
      if (image === null) {
        formData.append('image', '');
      } else if (image instanceof File) {
        formData.append('image', image);
      }
      return this.http.put(`${this.baseUrl}updateSubCategoryType/${typeId}`, formData);
    }
    return this.http.put(`${this.baseUrl}updateSubCategoryType/${typeId}`, {
      name,
      type,
    });
  }

  public deleteSubCategoryType(id) {
    return this.http.delete(`${this.baseUrl}deleteSubCategoryType/${id}`);
  }

  public addTypeToProduct(productId, typeId, isSubType = false) {
    return this.http.patch(`${this.baseUrl}addTypeToProduct`, {
      productId,
      typeId,
      isSubType,
    });
  }

  public removeTypeFromProduct(productId, typeId, isSubType = false) {
    return this.http.patch(`${this.baseUrl}removeTypeFromProduct`, {
      productId,
      typeId,
      isSubType,
    });
  }

  public getTypesOfProduct(productId, isSubType = false) {
    return this.http.get(
      `${this.baseUrl}getTypesOfProduct/${productId}?${isSubType ? 'isSubType=1&' : ''}`,
    );
  }

  public getTypeBySlug(slug: string) {
    return this.http.get(`${this.baseUrl}getTypeBySlug/${slug}`);
  }

  public getTypesOfCategory(categoryId) {
    return this.http.get(`${this.baseUrl}getTypesOfCategory/${categoryId}`);
  }

  public fetchProductsBasedOnTypes({
    types = [],
    isSubType = false,
    areTypesNames = false,
    page = 1,
    categoryId = -1,
    subregionId = [],
    subregionName = '',
    locationCondition = null,
  }: FetchProductsOptions) {
    //console.log({arguments})
    const queryParams = new URLSearchParams();

    queryParams.append('typesId', JSON.stringify(types));
    if (isSubType) queryParams.append('isSubType', '1');
    if (areTypesNames) queryParams.append('areTypesNames', '1');
    if (subregionName) queryParams.append('subregionName', subregionName);
    queryParams.append('page', page.toString());
    queryParams.append('categoryId', categoryId.toString());
    queryParams.append('subregionId', JSON.stringify(subregionId));
    if (locationCondition) {
      queryParams.append(
        'locationCondition',
        JSON.stringify(locationCondition),
      );
    }

    return this.http.get(
      `${this.baseUrl}fetchProductsBasedOnTypes?${queryParams.toString()}`,
    );
  }

  public getCategoryFAQInfo(id) {
    return this.http.get(
      `${this.baseUrl}getCategoryFAQInfo/${id}`,
    ) as Observable<ApiResponse>;
  }
  /***************************************************************************************************** */

  public deleteTag(id) {
    return this.http.delete(`${this.baseUrl}deleteTag/${id}`);
  }

  public getTotalTagsList(productId = null) {
    return this.http.post(`${this.baseUrl}getTotalTagsList`, { productId });
  }
  public getTagsOfProduct(productId) {
    return this.http.get(`${this.baseUrl}getTagsOfProduct/${productId}`);
  }
  public addTagToProduct(tagName, parentTagId, productId, isAdmin = false) {
    return this.http.post(`${this.baseUrl}addTagToProduct`, {
      tagName,
      parentTagId,
      productId,
      isAdmin,
    });
  }

  public removeTagFromProduct(tagName, productId) {
    return this.http.post(`${this.baseUrl}removeTagFromProduct`, {
      tagName,
      productId,
    });
  }

  public setSiteInfo(key: string, value: string) {
    return this.http.post(`${this.baseUrl}setSiteInfo`, { key, value });
  }
  public getSiteInfo(key: string) {
    return this.http.get(`${this.baseUrl}getSiteInfo/${key}`);
  }
  public getAllSiteInfos() {
    return this.http.get(
      `${this.baseUrl}getAllSiteInfos`,
    ) as Observable<ApiResponse>;
  }

  public addPromoOnProduct(payload): Observable<ApiResponse> {
    return this.http.post(
      `${this.baseUrl}addPromoOnProduct`,
      payload,
    ) as Observable<ApiResponse>;
  }
  public claimMoreSerive(refererId, moreServiceId, shopPromoCode) {
    return this.http.post(`${this.baseUrl}claimMoreSerive`, {
      refererId,
      moreServiceId,
      shopPromoCode,
    });
  }

  public registerVisit(screenDimensions) {
    return this.http.post(`${this.baseUrl}registerVisitor`, {
      screenDimensions,
    });
  }
  public getVisitorInfos() {
    return this.http.get(`${this.baseUrl}getVisitorInfos`);
  }
  public increaseLoginBecauseOfProductCount(productId) {
    return this.http.post(`${this.baseUrl}increaseLoginBecauseOfProductCount`, {
      productId,
    });
  }
  public increaseViewCountOfProduct(productId) {
    return this.http.post(`${this.baseUrl}increaseViewCountOfProduct`, {
      productId,
    });
  }

  public getAllHomePageMidCategories() {
    return this.http.get(
      `${this.baseUrl}getAllHomePageMidCategories`,
    ) as Observable<ApiResponse>;
  }
  public uploadHomePageMidCategory(
    categoryId,
    { image, caption, url }: { image?: File; caption: string; url?: string },
  ) {
    const payload = new FormData();
    payload.append('caption', caption);
    if (image) {
      payload.append('image', image);
    } else if (url) {
      payload.append('url', url);
    } else {
      throw new Error('either image or url is required!');
    }
    return this.http.post(
      `${this.baseUrl}uploadHomePageMidCategory/${categoryId}`,
      payload,
    );
  }

  public removeHomepageMidCategory(categoryId) {
    return this.http.delete(
      `${this.baseUrl}removeHomepageMidCategory/${categoryId}`,
    );
  }

  public getAllHomepageAds() {
    return this.http.get(`${this.baseUrl}getAllHomepageAds`);
  }

  public createHomepageAd(payload) {
    return this.http.post(`${this.baseUrl}createHomepageAd`, payload);
  }

  public deleteHomepageAd(adId) {
    return this.http.delete(`${this.baseUrl}/deleteHomepageAd/${adId}`);
  }

  public recommendProductFromDb(data) {
    return this.http.post(`${this.baseUrl}recommendProductFromDb`, data);
  }
  public getCountsOfRecommendationCategoriestInSubRegion(subRegionId) {
    return this.http.post(
      `${this.baseUrl}getCountsOfRecommendationCategoriestInSubRegion`,
      { subRegionId },
    );
  }
  public editRecommendation(recommId, data, options?: any) {
    return this.http.patch(
      `${this.baseUrl}editRecommendation/${recommId}`,
      data,
      options,
    );
  }

  public deleteRecommendation(recommId) {
    return this.http.delete(`${this.baseUrl}deleteRecommendation/${recommId}`);
  }
  public getCountsOfRolesInUsersSubRegion(subRegionId) {
    return this.http.post(`${this.baseUrl}getCountsOfRolesInUsersSubRegion`, {
      subRegionId,
    });
  }
  public toggleIsRoleOnOffOnCategory(categoryId, roleName = null) {
    return this.http.post(`${this.baseUrl}toggleIsRoleOnOffOnCategory`, {
      categoryId,
      roleName,
    });
  }
  public toggleRecommendationReaction(recommendationId) {
    return this.http.post(`${this.baseUrl}toggleRecommendationReaction`, {
      recommendationId,
    });
  }
  public getallrecommendations({
    categries = [],
    selectAllRegions = false,
    isUsers = false,
    userId = null,
  }) {
    return this.http.post(`${this.baseUrl}getallrecommendations`, {
      categries,
      selectAllRegions,
      isUsers,
      userId,
    });
  }
  public addRecommendations(payload, options?: any) {
    return this.http.post(
      `${this.baseUrl}addRecommendations`,
      payload,
      options,
    );
  }
  public toggleVerifyReaction(verifyId) {
    return this.http.post(`${this.baseUrl}toggleVerifyReaction`, { verifyId });
  }

  public getSubRegionProductCounts() {
    return this.http.get(`${this.baseUrl}getSubRegionProductCounts`);
  }
  public getMemberShopSubRegionBaseOnProducts(subCategories = null) {
    return this.http.get(
      `${this.baseUrl}getMemberShopSubRegionBaseOnProducts` +
        (subCategories && subCategories.length
          ? `?subCategories=${encodeURI(JSON.stringify(subCategories))}`
          : ``),
    );
  }
  public getBizInfo(id) {
    return this.http.get(`${this.baseUrl}getBizInfo/${id}`);
  }

  public getBizInfos(category = null) {
    return this.http.get(
      `${this.baseUrl}getBizInfos${category ? '?category=' + category : ''}`,
    );
  }
  public getShopIdList(category = null) {
    return this.http.get(
      `${this.baseUrl}getShopIdList${category ? '?category=' + category : ''}`,
    );
  }
  public getMySupports(): Observable<any> {
    return this.http.get(`${this.baseUrl}getMySupports`);
  }
  public getUsersByReferralId(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getUsersByReferralId`, payload);
  }

  public deleteBizMessage(messageId): Observable<any> {
    return this.http.post(`${this.baseUrl}deleteBizMessage`, { messageId });
  }

  public getAllBizMessages(bizUserDetailsId, isShopId = true): Observable<any> {
    return this.http.get(
      `${this.baseUrl}getAllBizMessages?bizUserDetailsId=${bizUserDetailsId}&isShopId=${isShopId}`,
    );
  }

  public createBizMessage(payload: {
    message: string;
    isForLoginUserOnly: boolean;
  }): Observable<any> {
    return this.http.post(`${this.baseUrl}createBizMessage`, payload);
  }

  //biz telegram

  addChatNotification = (
    toAppUserId,
    type: 'whatsapp' | 'book-now' | 'chat-notif',
    others = {},
  ) => {
    return this.http.post(environment.baseUrlAdmin + '/addChatNotification', {
      toAppUserId,
      type,
      ...others,
    });
  };
  getBizTgBotRegistration = () => {
    return this.http.get(environment.baseUrlAdmin + '/getBizTgBotRegistration');
  };
  registerBizTgBot = (tgToken: string) => {
    return this.http.post(environment.baseUrlAdmin + '/registerBizTgBot', {
      tgToken,
    });
  };

  sendCashBackPaymentSuccessEmail = (id) => {
    return this.http.post(
      this.baseUrl + 'sendCashBackPaymentSuccessEmail/' + id,
      {},
    );
  };

  get_bad_words = () => {
    return this.http.get(environment.baseUrlAdmin + '/get_bad_words');
  };

  add_bad_word = (word) => {
    return this.http.post(environment.baseUrlAdmin + 'add_bad_word', {
      word,
    });
  };
  remove_bad_word = (word) => {
    return this.http.post(environment.baseUrlAdmin + '/remove_bad_word', {
      word,
    });
  };
  set_telegram_job_is_completed = (jobId) => {
    return this.http.put(
      environment.ImageUrl + 'api/setTelegramJobIsCompleted',
      {
        jobId,
      },
    );
  };

  remove_chat_from_archives = (chatId, isBiz = false) => {
    return this.http.post(
      environment.baseUrlAdmin + '/remove_chat_from_archives',
      { chatId, isBiz },
    );
  };

  add_chat_to_archives = (chatId, isBiz = false) => {
    return this.http.post(environment.baseUrlAdmin + '/add_chat_to_archives', {
      chatId,
      isBiz,
    });
  };

  ack_report = (reportId) => {
    return this.http.post(environment.baseUrlAdmin + 'ack_chat_report', {
      reportId,
    });
  };
  get_telegram_verification_link = () => {
    return this.http.get(
      environment.baseUrlAdmin + 'getTelegramVerificationLink',
    );
  };
  verifyAppUserPhone = () => {
    return this.http.post(environment.baseUrlAdmin + 'verifyAppUserPhone', {});
  };

  get_chat_reports = () => {
    return this.http.get(environment.baseUrlAdmin + 'get_chat_reports');
  };

  report_chat_message = (messageId, remark: null | string = null) => {
    return this.http.post(environment.baseUrlAdmin + 'report_message', {
      messageId,
      remark,
    });
  };

  private nextTypingTime = new Date();

  //adminApp/get_chats_with_count
  get_my_blocks = () => {
    return this.http.get(environment.baseUrlAdmin + `my_blocks`);
  };
  have_i_blocked_user = (chatId, isBiz = false) => {
    return this.http.get(
      environment.baseUrlAdmin +
        `have_i_blocked_user?chatId=${chatId}&isBiz=${isBiz}`,
    );
  };
  block_user = (chatId, isProfileBiz = false) => {
    return this.http.post(environment.baseUrlAdmin + `block_user`, {
      chatId,
      isProfileBiz,
    });
  };
  unblock_user = (chatId, isProfileBiz = false) => {
    return this.http.post(environment.baseUrlAdmin + `unblock_user`, {
      chatId,
      isProfileBiz,
    });
  };

  ban_chat_user = (userId?: number, ipAddress?: string) => {
    return this.http.post(environment.baseUrlAdmin + `ban_chat_user`, {
      userId: userId || null,
      ipAddress: ipAddress || null,
    });
  };

  has_user_blocked_me = (chatId, isBiz = false) => {
    return this.http.get(
      environment.baseUrlAdmin +
        `has_user_blocked_me?chatId=${chatId}&isBiz=${isBiz}`,
    );
  };

  get_chat_data = (chatId, isBizAcc = false) => {
    return this.http.get(
      environment.baseUrlAdmin +
        `get_chat_data?chatId=${chatId}&isBizAcc=${isBizAcc ?? ''}`,
    );
  };
  getDistanceBetweenPostalCodes = (p2, p1) => {
    return this.http.get(
      environment.baseUrlAdmin +
        `getDistanceFromPostalCodes?destionationPostalCode=${p1}&pickupPostalCode=${p2}`,
    );
  };
  get_total_unread_message_count = () => {
    return this.http.get(this.baseUrl + 'get_total_unread_message_count');
  };
  send_typing_message = (chatId, isForBiz = false) => {
    const now = new Date();

    if (this.nextTypingTime > now) {
      return null;
    }
    this.nextTypingTime = new Date(now.getTime() + 1500);
    return this.http.post(this.baseUrl + '/send_typing_message', {
      chatId,
      isForBiz,
    });
  };
  register_device = (deviceFCMId: any) => {
    return this.http.post(this.baseUrl + '/registerAppUserDevice', {
      deviceFCMId,
      deviceType: 'WEB',
    });
  };
  delete_fcm_token = (oldFCMToken: any) => {
    return this.http.post(this.baseUrl + '/deleteFCMToken', { oldFCMToken });
  };
  get_chats_with_count = ({ since = null, separateByType = false }) => {
    const params = new URLSearchParams();

    if (since !== null) params.append('since', since);
    if (separateByType === true) params.append('separateByType', 'true');

    return this.http.get(
      `${this.baseUrl}get_chats_with_counts?${params.toString()}`,
    );
  };

  send_message = (args, isForBiz = false) => {
    const { to, textContent, imageContent, aboutProductId, fromName, ipAddress, tempName } = args;
    const data = new FormData();
    data.append('to', to);
    data.append('textContent', textContent);
    if (aboutProductId) {
      data.append('aboutProductId', aboutProductId);
    }
    if (imageContent) {
      data.append('imageFile', imageContent);
    }
    data.append('isForBiz', isForBiz.toString());
    const { forTypeId, forCategoryId } = args;

    if (forTypeId) {
      data.append('forTypeId', forTypeId?.toString());
    }
    if (forCategoryId) {
      data.append('forCategoryId', forCategoryId?.toString());
    }
    if (fromName) {
      data.append('fromName', fromName);
    }
    if (ipAddress) {
      data.append('ipAddress', ipAddress);
    }
    if (tempName) {
      data.append('tempName', tempName);
    }
    return this.http.post(this.baseUrl + 'send_chat_message', data, {
      reportProgress: true,
      observe: 'events',
    });
  };
  delete_chat_message = (messageId: number) => {
    return this.http.post(this.baseUrl + 'delete_chat_message', {
      messageId,
    });
  };
  getTemporaryName =  (ipAddress: string)=>{
     return this.http.get(`${this.baseUrl}getTemporaryName?ipAddress=${encodeURIComponent(ipAddress)}`) as Observable<ApiResponse>
  }
  fetch_chat_message = (
    chatId,
    {
      before = null,
      after = null,
      isFromBiz = false,
      forTypeId = null,
      forCategoryId = null,
    } = {},
  ) => {
    const params = new URLSearchParams();
    params.append('chatId', chatId);
    params.append('isFromBiz', isFromBiz.toString());

    if (before !== null) params.append('before', before);
    if (after !== null) params.append('after', after);
    if (forTypeId !== null) params.append('forTypeId', forTypeId);
    if (forCategoryId !== null) params.append('forCategoryId', forCategoryId);

    return this.http.get(
      `${this.baseUrl}fetch_chat_message?${params.toString()}`,
    );
  };

  getTotalUnreadMessageCountForGroups = ({typeId, categoryId})=>{
    const params = new URLSearchParams()
    if(typeId){
      params.append('forTypeId', typeId)
    }else if(categoryId){
      params.append('forCategoryId', categoryId)
    }
    return this.http.get(`${this.baseUrl}getTotalUnreadMessageCountForGroups?${params.toString()}`) as Observable<ApiResponse>
  }

  make_chat_messages_seen = (chatId, isBizChat, {forTypeId=null, forCategoryId=null}={}) => {
    //console.log('invalidating chatt')
    const params = new URLSearchParams()
    if(forTypeId){
      params.append('forTypeId', forTypeId)
    }else if(forCategoryId){
      params.append('forCategoryId', forCategoryId)
    }

    return this.http.post(this.baseUrl + `make_chat_messages_seen?${params.toString()}`, {
      chatId,
      isBizChat,
    });
  };

  login = (requestData) => {
    //console.log('here');
    return this.http.post(this.baseUrl + 'login', requestData);
  };
  get_available_promotions = () => {
    return this.http.get(this.baseUrl + 'get_available_promotions');
  };

  postToTelegramChannels = (payload) => {
    const URL = environment.ImageUrl + 'api/postToTelegramChannels';
    return this.http.post(URL, payload, this.header.formheader());
  };

  getUserVoucher = (uid) => {
    return this.http.get(
      this.baseUrl + `promationVouchers/${uid}`,
      this.header.formheader(),
    );
  };

  getProfile = () => {
    return this.http.get(
      this.baseUrl + 'getMyProfile',
      this.header.formheader(),
    );
  };

  getDashboardSubAdmin = () => {
    return this.http.get(
      this.baseUrl + 'getDashboardSubAdmin',
      this.header.formheader(),
    );
  };

  suadmindata = () => {
    return this.http.get(
      this.baseUrl + 'getAllSubadmin',
      this.header.formheader(),
    );
  };
  getRemark = () => {
    return this.http.get(
      this.baseUrl + 'getAllRemark',
      this.header.formheader(),
    );
  };

  getcallLogdata = () => {
    return this.http.get(
      this.baseUrl + 'getcallLogdata',
      this.header.formheader(),
    );
  };

  addCallLogData = (data) => {
    return this.http.post(this.baseUrl + `addCallLogData`, data);
  };

  getTemplate = (roleid) => {
    return this.http.get(
      this.baseUrl + `get_all_templates/${roleid}`,
      this.header.formheader(),
    );
  };

  getReciepts = () => {
    return this.http.get(this.baseUrl + 'receipts', this.header.formheader());
  };

  getUserProfile = (uid) => {
    return this.http.get(
      this.baseUrl + `userData/${uid}`,
      this.header.formheader(),
    );
  };

  addReciept = (data, uid) => {
    return this.http.post(this.baseUrl + `addReceipt/${uid}`, data);
  };

  getUser = (uid) => {
    return this.http.get(
      this.baseUrl + `user/${uid}`,
      this.header.formheader(),
    );
  };
  changeMemberStatus = (uid, membertype) => {
    return this.http.put(
      this.baseUrl + `changeMemberType/${uid}/${membertype}`,
      this.header.formheaderP(),
    );
  };

  addNote = (requestdata) => {
    return this.http.post(this.baseUrl + `add_note`, requestdata);
  };

  get_all_actions = () => {
    return this.http.get(this.baseUrl + `get_admin_action_list`);
  };

  get_all_admins_actions = () => {
    return this.http.get(this.baseUrl + `get_all_admin_action_list`);
  };

  getSubNote = () => {
    return this.http.get(this.baseUrl + `get_notes`);
  };

  getSubNoteWithoutLogin = () => {
    return this.http.get(this.baseUrl + `get_admin_notes`);
  };

  getAllSubadmins = () => {
    return this.http.get(this.baseUrl + `get_all_admins`);
  };

  getRepairTemplate = (data) => {
    return this.http.post(this.baseUrl + `get_repair_template_web`, data);
  };

  getLastFiveSearch = () => {
    return this.http.get(this.baseUrl + `get_last_five_searches`);
  };

  getRepairProcessSearch = () => {
    return this.http.get(this.baseUrl + `get_repair_process_search`);
  };

  searchCustRepair = (data) => {
    return this.http.post(this.baseUrl + `search_user_repair_process`, data);
  };

  getAllCharacter = () => {
    return this.http.get(this.baseUrl + `get_all_characteristics_web`);
  };

  getAllCharacterTotal = () => {
    return this.http.get(this.baseUrl + `get_characteristics_count_per_admin`);
  };

  deleteSubNote = (data) => {
    // //console.log(data);
    return this.http.request('delete', this.baseUrl + `delete_notes`, {
      body: data,
    });
  };

  addNoteCustomer = (requestdata) => {
    return this.http.post(this.baseUrl + `add_customer_note`, requestdata);
  };

  getCustomerNote = (data) => {
    return this.http.post(this.baseUrl + `get_customer_notes`, data);
  };

  deleteCustomerNote = (data) => {
    //console.log(data);
    return this.http.request('delete', this.baseUrl + `delete_customer_notes`, {
      body: data,
    });
  };

  editCustomerDetail = (requestdata) => {
    return this.http.post(this.baseUrl + `edit_customer_detail`, requestdata);
  };

  assignChar = (requestdata) => {
    return this.http.post(this.baseUrl + `assign_characteristics`, requestdata);
  };

  member_signUp = (requestdata) => {
    return this.http.post(this.baseUrl + `member_signup`, requestdata);
  };

  send_member_signUp_message = (requestdata) => {
    return this.http.post(
      this.baseUrl + `send_message_to_signup_user`,
      requestdata,
    );
  };

  apply_promotional_vouture = (requestdata) => {
    return this.http.put(
      this.baseUrl + `update_available_promotions`,
      requestdata,
    );
  };

  deleteMember = (data) => {
    // //console.log(data);
    return this.http.request('delete', this.baseUrl + `delete_member`, {
      body: data,
    });
  };

  sortActions = (data) => {
    return this.http.post(this.baseUrl + 'getDataSorting', data);
  };

  sendTemplate = (data) => {
    return this.http.post(this.baseUrl + 'send_template', data);
  };

  filterData = (data) => {
    return this.http.post(this.baseUrl + 'get_filtered_data', data);
  };

  blockUnblockCust = (data) => {
    return this.http.post(this.baseUrl + 'blockUsers', data); //type -> 1 block type -> 0 unblock
  };

  sendBulkSms = (data) => {
    return this.http.post(this.baseUrl + 'sendBulkSms', data);
  };

  Claimed = (data) => {
    return this.http.post(this.baseUrl + 'claim_user', data);
  };

  send_sms_on_complete_repair = (data) => {
    return this.http.post(this.baseUrl + 'send_repair_process_message', data);
  };

  save_repair_process_changes = (data) => {
    return this.http.post(this.baseUrl + 'saveRepairProcessPopup', data);
  };

  save_future_sms_data = (data) => {
    return this.http.post(this.baseUrl + 'saveFutureSms', data);
  };

  add_feedback = (data) => {
    return this.http.post(this.baseUrl + 'add_feedback', data);
  };

  get_feedback_manager_url_data = (url) => {
    return this.http.get(this.baseUrl + `get_feedback_manager_url_data/${url}`);
  };

  skipFeedback = (data) => {
    return this.http.post(this.baseUrl + 'skipFeedback', data);
  };

  add_feedback_subadmin = (data) => {
    return this.http.post(this.baseUrl + 'add_feedback_subadmin', data);
  };

  checkLastIpFeedback = (data) => {
    return this.http.post(this.baseUrl + 'checkLastIpFeedback', data);
  };

  get_all_feedback = (url) => {
    return this.http.get(this.baseUrl + `get_feedback/${url}`);
  };

  get_all_feedback_module = (formData) => {
    return this.http.post(this.baseUrl + 'get_feedback_module', formData);
  };

  get_customers_data_sms = (data) => {
    return this.http.post(this.baseUrl + 'get_user_listing_monthwise', data);
  };

  add_process_step1 = (data) => {
    return this.http.post(this.baseUrl + 'add_process_step', data);
  };

  get_process_step_data = (data) => {
    return this.http.post(this.baseUrl + 'get_process_step', data);
  };
  get_process_final_list = (data) => {
    return this.http.post(this.baseUrl + 'get_final_process_listing', data);
  };

  add_schedule = (data) => {
    return this.http.post(this.baseUrl + 'add_slot', data);
  };

  getTimeSlots = (data) => {
    return this.http.post(this.baseUrl + 'slot_listing', data);
  };

  getEventData = (data) => {
    return this.http.post(this.baseUrl + 'get_calendar_data_filter', data);
  };

  get_all_calendar_data = () => {
    return this.http.get(this.baseUrl + 'get_calendar_data');
  };

  get_all_calendar_receipts = (data) => {
    return this.http.post(this.baseUrl + 'get_boxes_data', data);
  };

  schedule_button = (data) => {
    return this.http.post(this.baseUrl + 'boxes_four_buttons', data);
  };

  get_Slots_actions = () => {
    return this.http.get(this.baseUrl + 'get_slot_actions');
  };

  get_invoice_products = () => {
    return this.http.get(this.baseUrl + 'item_listing');
  };

  place_invoice_order = (data) => {
    return this.http.post(this.baseUrl + 'place_order', data);
  };

  order_invoice_filter = (data) => {
    return this.http.post(this.baseUrl + 'order_filter', data);
  };

  send_receipt_email = (data) => {
    return this.http.post(this.baseUrl + 'send_order', data);
  };

  get_outlet_stores = () => {
    return this.http.get(this.baseUrl + 'get_outlets');
  };

  get_outlet_categories = () => {
    return this.http.get(this.baseUrl + 'get_outlet_options');
  };

  add_phone = (data) => {
    return this.http.post(this.baseUrl + 'save_outlet', data);
  };

  edit_phone = (data) => {
    return this.http.post(this.baseUrl + 'edit_outlet', data);
  };

  get_outlet_all_data = () => {
    return this.http.get(this.baseUrl + 'outlets_data');
  };

  change_outlet_receipt_status = (data) => {
    return this.http.post(this.baseUrl + 'change_outlet_status', data);
  };

  get_outlet_actions = (data) => {
    return this.http.post(this.baseUrl + 'outlet_action_list', data);
  };

  add_value_amount = (data) => {
    return this.http.post(this.baseUrl + 'add_value', data);
  };

  deduct_value_amount = (data) => {
    return this.http.post(this.baseUrl + 'deduct_value', data);
  };

  get_all_data = (data) => {
    return this.http.post(this.baseUrl + 'get_values_and_actions', data);
  };

  send_value_sms = (data) => {
    return this.http.post(this.baseUrl + 'send_value_action', data);
  };

  add_phone_pdf = (data) => {
    return this.http.post(this.baseUrl + 'create_value_pdf', data);
  };

  add_value_excel = (data) => {
    return this.http.post(this.baseUrl + 'create_value_excel', data);
  };

  get_score_all_admins = () => {
    return this.http.get(this.baseUrl + 'admin_and_characteristics_listing');
  };

  add_character_score = (data) => {
    return this.http.post(this.baseUrl + 'add_star_rating', data);
  };

  add_feedback_score = (data) => {
    return this.http.post(this.baseUrl + 'add_star_feedback', data);
  };

  save_all_Stars = () => {
    return this.http.get(this.baseUrl + 'save_all_stars');
  };

  get_all_admins_stars = (data) => {
    return this.http.post(
      this.baseUrl + 'get_all_admin_and_characteristics_listing',
      data,
    );
  };

  refresh_all_Stars = () => {
    return this.http.get(this.baseUrl + 'refresh_stars');
  };

  update_left_values_profile = (data) => {
    return this.http.post(this.baseUrl + 'saveSalesStockGross', data);
  };

  get_prof_data_admin_filter = (data) => {
    return this.http.post(this.baseUrl + 'get_all_counts', data);
  };

  get_all_counts_outlets = (data) => {
    return this.http.post(this.baseUrl + 'get_all_counts_outlets', data);
  };

  save_ip_address = (data) => {
    return this.http.post(this.baseUrl + 'saveIpAddress', data);
  };

  get_user_detl = (data) => {
    return this.http.post(this.baseUrl + 'get_user_details', data);
  };

  get_ip_address_listing = () => {
    return this.http.get(this.baseUrl + 'ipAddressListing');
  };

  get_inventory_outlets = () => {
    return this.http.get(this.baseUrl + 'listing_inventory_outlets');
  };

  set_inventory_outlet_default = (formData) => {
    return this.http.post(
      this.baseUrl + 'set_inventory_outlet_default',
      formData,
    );
  };

  get_inventory_outlets_by_index = (type) => {
    return this.http.get(
      this.baseUrl + 'listing_inventory_outlets_by_index/' + type,
    );
  };

  get_inventory_items = (data) => {
    return this.http.post(this.baseUrl + 'listing_inventory_website', data);
  };

  get_inventory_categories = () => {
    return this.http.get(this.baseUrl + 'listing_inventory_category');
  };

  get_inventory_SubCat = (data) => {
    return this.http.post(
      this.baseUrl + 'get_inventory_subcategory_acc_to_category',
      data,
    );
  };

  add_star_inventory_item = (data) => {
    return this.http.post(this.baseUrl + 'listing_inventory_add_star', data);
  };

  add_invoice_inventory = (data) => {
    return this.http.post(this.baseUrl + 'inventory_add_invoice', data);
  };

  add_warranty_system_inventory = (data) => {
    return this.http.post(
      this.baseUrl + 'inventory_warranty_system_used',
      data,
    );
  };

  get_invoices_inventory = (data) => {
    return this.http.post(this.baseUrl + 'inventory_invoice_listing', data);
  };

  get_actions_inventory = (data) => {
    return this.http.post(this.baseUrl + 'inventory_action_list', data);
  };

  get_inventory_count_difference = (data) => {
    return this.http.post(
      this.baseUrl + 'inventory_current_counted_quantity_listing',
      data,
    );
  };

  get_inventory_reOrder_items = (data) => {
    return this.http.post(this.baseUrl + 'inventory_reorder_list', data);
  };

  save_inventory_difference = (data) => {
    return this.http.post(
      this.baseUrl + 'inventory_current_counted_quantity',
      data,
    );
  };

  change_invoice_status = (data) => {
    return this.http.post(this.baseUrl + 'accept_paid_inventory', data);
  };

  deleteItemInventory = (data) => {
    return this.http.post(this.baseUrl + 'delete_inventory_website', data);
  };

  editItemInventory = (data) => {
    return this.http.post(this.baseUrl + 'edit_inventory_website', data);
  };

  reOrderInventoryItem = (data) => {
    return this.http.post(this.baseUrl + 'inventory_reorder_save', data);
  };

  change_difference_status = (data) => {
    return this.http.post(this.baseUrl + 'inventory_accept_trash', data);
  };

  delete_invoice = (data) => {
    return this.http.post(this.baseUrl + 'delete_invoice', data);
  };

  save_user_details = (data) => {
    return this.http.post(this.baseUrl + 'saveUserNewData', data);
  };

  keyword_user_filter = (data) => {
    return this.http.post(this.baseUrl + 'filterUserData', data);
  };

  save_current_counted_difference = (data) => {
    return this.http.post(this.baseUrl + 'current_counted_actual_save', data);
  };

  delete_customer_file = (data) => {
    return this.http.post(this.baseUrl + 'deleteFile', data);
  };

  upload_customer_new_file = (data) => {
    return this.http.post(this.baseUrl + 'uploadUserFiles', data);
  };

  new_signup_customer_actions_listing = () => {
    return this.http.get(this.baseUrl + 'selfServiceListing');
  };

  redeem_verify_customer_action = (data) => {
    return this.http.post(
      this.baseUrl + 'verifyReceiptOrRedeemPromotion',
      data,
    );
  };

  add_repair_step_process_home = (data) => {
    return this.http.post(this.baseUrl + 'add_process_step_new', data);
  };

  get_repair_process_new = () => {
    return this.http.get(this.baseUrl + 'get_final_process_listing_new');
  };

  get_feedback_settings = (data) => {
    return this.http.post(this.baseUrl + 'get_all_feedbacks', data);
  };

  graphs_score_settings = (data) => {
    return this.http.post(this.baseUrl + 'score_graph_data', data);
  };

  complete_repair_process = (data) => {
    return this.http.post(this.baseUrl + 'complete_add_process_new', data);
  };

  cancelled_repair_process = (data) => {
    return this.http.post(this.baseUrl + 'cancelRepairProcessNew', data);
  };

  cancelled_client_position = (data) => {
    return this.http.post(this.baseUrl + 'delete_client_position', data);
  };

  edit_client_position = (data) => {
    return this.http.post(this.baseUrl + 'edit_client_position', data);
  };

  edit_cust_detail_search2 = (data) => {
    return this.http.post(this.baseUrl + 'edit_client_position', data);
  };

  get_completed_repair = (formData) => {
    return this.http.post(
      this.baseUrl + 'get_completed_process_listing_new',
      formData,
    );
  };

  get_completed_process_listing_tab = (formData) => {
    return this.http.post(
      this.baseUrl + 'get_completed_process_listing_tab',
      formData,
    );
  };

  get_repair_data_from_phone_admin = (data) => {
    return this.http.post(this.baseUrl + 'get_repair_data_from_phone', data);
  };

  get_repair_admin = (data) => {
    //console.log(data);
    return this.http.post(this.baseUrl + 'get_final_process_listing_new', data);
  };

  get_friends_history = (data) => {
    //console.log(data);
    return this.http.post(this.baseUrl + 'friends_history', data);
  };

  friends_history_new_from_process = (data) => {
    //console.log(data);
    return this.http.post(
      this.baseUrl + 'friends_history_new_from_process',
      data,
    );
  };

  get_friends_history_right = (data) => {
    //console.log(data);
    return this.http.post(this.baseUrl + 'friends_history_right', data);
  };

  save_notes_repair = (data) => {
    return this.http.post(this.baseUrl + 'saveProcessNote', data);
  };

  edit_settings_data = (data) => {
    return this.http.post(this.baseUrl + 'editSalesStockGross', data);
  };

  saveNotes_addphone = (data) => {
    return this.http.post(this.baseUrl + '', data);
  };

  //----------------------------------Customers api --------------------------------------------------------------------

  login_signup_new_customer = (data) => {
    return this.http.post(this.baseUrl + 'member_login_user', data);
  };

  login_signup_new_customer_marketplace(data) {
    return this.http.post(this.baseUrl + 'member_login_user_marketplace', data);
  }

  member_verify_otp = (data) => {
    return this.http.post(this.baseUrl + 'member_verify_otp', data);
  };

  member_send_otp = (data) => {
    return this.http.post(this.baseUrl + 'member_send_otp', data);
  };

  member_save_password = (data) => {
    return this.http.post(this.baseUrl + 'member_save_password', data);
  };

  member_reset_passcode = (data) => {
    return this.http.post(this.baseUrl + 'member_reset_passcode', data);
  };

  logout_customer_marketplace = (data) => {
    return this.http.post(
      this.baseUrl + 'member_logout_user_marketplace',
      data,
    );
  };

  check_customer_exists = (data) => {
    return this.http.post(
      this.baseUrl + 'member_login_user_check_member_type',
      data,
    );
  };

  get_customer_detail = (uid) => {
    return this.http.get(
      this.baseUrl + `get_customer_details/${uid}`,
      this.header.formheader(),
    );
  };

  save_faq_query = (data) => {
    return this.http.post(this.baseUrl + `did_you_call_before_coming`, data);
  };

  use_available_coupons = (data) => {
    return this.http.put(
      this.baseUrl + `update_available_promotions_customer`,
      data,
    );
  };

  add_customer_friend = (data) => {
    return this.http.post(this.baseUrl + `add_friend`, data);
  };

  get_customer_friend_list = () => {
    return this.http.get(this.baseUrl + 'friend_listing');
  };

  delete_customer_friend = (data) => {
    return this.http.post(this.baseUrl + `delete_friend`, data);
  };

  add_receipts_customer = (data) => {
    return this.http.post(this.baseUrl + `addReceiptCustomer`, data);
  };

  remove_receipts_customer = (data) => {
    return this.http.post(this.baseUrl + `deleteReceiptCustomer`, data);
  };

  verify_receipts_customer = (data) => {
    return this.http.post(this.baseUrl + `verifyReceiptCustomer`, data);
  };

  edit_customer_profile = (data) => {
    return this.http.post(this.baseUrl + `edit_customer_detail_customer`, data);
  };

  forgot_password_customer = (data) => {
    return this.http.post(this.baseUrl + `forgot_password`, data);
  };

  set_new_password_customer = (data) => {
    return this.http.post(this.baseUrl + `reset_password`, data);
  };

  get_customer_feedback = () => {
    return this.http.get(this.baseUrl + `get_customers_feedbacks`);
  };

  delete_customer_feedback = (data) => {
    return this.http.post(this.baseUrl + `delete_customer_feedback`, data);
  };

  add_repair_customer = (data) => {
    return this.http.post(this.baseUrl + `add_process_step_new_customer`, data);
  };

  get_customer_repair = (formData) => {
    return this.http.post(
      this.baseUrl + `get_final_process_listing_new_customer`,
      formData,
    );
  };

  add_client_new = (formData) => {
    return this.http.post(this.baseUrl + `add_client`, formData);
  };

  add_position_new = (formData) => {
    return this.http.post(this.baseUrl + `add_client_position`, formData);
  };

  save_Sell_phone = (formData) => {
    return this.http.post(this.baseUrl + `save_phone`, formData);
  };

  change_Sell_phone_status = (formData) => {
    return this.http.post(this.baseUrl + `save_phone`, formData);
  };

  filter_outlet_data = (formData) => {
    return this.http.post(this.baseUrl + `outlets_data_filter`, formData);
  };

  get_all_client_data = () => {
    return this.http.get(this.baseUrl + `client_listing`);
  };
  get_all_phone_count = (type) => {
    return this.http.post(this.baseUrl + `get_outlet_counts_prices`, type);
  };

  get_all_customer_data_new = (formData) => {
    return this.http.post(this.baseUrl + `getAllUsersMonthwise`, formData);
  };

  save_stars_for_cv_rating = (data) => {
    return this.http.post(this.baseUrl + `save_stars_for_cv_rating`, data);
  };

  delete_search2_list_user = (data) => {
    return this.http.post(this.baseUrl + `search2DeleteUsers`, data);
  };

  // ----------------------------------------Shopping module apis----------------------------------------------

  addCategory = (formData) => {
    return this.http.post(this.baseUrl + `add_food_category`, formData);
  };

  addSubCategory = (formData) => {
    return this.http.post(this.baseUrl + `add_food_sub_category`, formData);
  };

  getFoodCategories = (adminId) => {
    return this.http.get(this.baseUrl + `get_all_food_categories/${adminId}`);
  };

  getFoodCategoriesCustomer = (clientId) => {
    return this.http.get(
      this.baseUrl + `get_all_food_categories_customer/${clientId}`,
    );
  };

  getFoodSubCategories = (formData) => {
    return this.http.post(
      this.baseUrl + `get_all_food_sub_categories`,
      formData,
    );
  };

  editFoodCategories = (formData) => {
    return this.http.post(this.baseUrl + `edit_food_categories`, formData);
  };

  editFoodSubCategories = (formData) => {
    return this.http.post(this.baseUrl + `edit_food_sub_categories`, formData);
  };

  get_client_position_acc_to_client_selected = (formData) => {
    return this.http.post(
      this.baseUrl + `get_client_position_acc_to_client_selected`,
      formData,
    );
  };

  save_send_resume = (formData) => {
    return this.http.post(this.baseUrl + `save_send_resume`, formData);
  };

  saveSendResumeRemarks = (formData) => {
    return this.http.post(this.baseUrl + `saveSendResumeRemarks`, formData);
  };

  get_send_resume_listing_in_client_page = (formData) => {
    return this.http.post(
      this.baseUrl + `get_send_resume_listing_in_client_page`,
      formData,
    );
  };

  get_file_contents = (formData) => {
    return this.http.post(this.baseUrl + `get_file_contents`, formData);
  };

  delete_send_resume = (formData) => {
    return this.http.post(this.baseUrl + `delete_send_resume`, formData);
  };

  add_food = (formData) => {
    return this.http.post(this.baseUrl + `add_food`, formData);
  };

  updateFoodPercent = (formData) => {
    return this.http.post(this.baseUrl + `updateFoodPercent`, formData);
  };

  food_listing = (formData) => {
    return this.http.post(this.baseUrl + `food_listing`, formData);
  };

  food_listing_customer = (formData) => {
    return this.http.post(this.baseUrl + `food_listing_customer`, formData);
  };

  delete_food = (formData) => {
    return this.http.post(this.baseUrl + `delete_food`, formData);
  };

  get_food_details = (formData) => {
    return this.http.post(this.baseUrl + `get_food_details`, formData);
  };

  edit_food = (formData) => {
    return this.http.post(this.baseUrl + `edit_food`, formData);
  };

  add_to_cart = (formData) => {
    return this.http.post(this.baseUrl + `add_to_cart`, formData);
  };

  add_to_cart_without_login = (formData) => {
    return this.http.post(this.baseUrl + `add_to_cart_without_login`, formData);
  };

  cart_listing = (client_id, visitorId) => {
    return this.http.get(
      this.baseUrl + `cart_listing/${client_id}/${visitorId}`,
    );
  };

  cart_listing_without_login = (client_id, visitorId) => {
    return this.http.get(
      this.baseUrl + `cart_listing_without_login/${client_id}/${visitorId}`,
    );
  };

  add_cart_remarks = (formData) => {
    return this.http.post(this.baseUrl + `add_cart_remarks`, formData);
  };

  add_cart_remarks_without_login = (formData) => {
    return this.http.post(
      this.baseUrl + `add_cart_remarks_without_login`,
      formData,
    );
  };

  delete_cart_item = (formData) => {
    return this.http.post(this.baseUrl + `delete_cart_item`, formData);
  };

  delete_cart_item_without_login = (formData) => {
    return this.http.post(
      this.baseUrl + `delete_cart_item_without_login`,
      formData,
    );
  };

  confirm_payment = (formData) => {
    return this.http.post(this.baseUrl + `confirm_payment`, formData);
  };

  confirm_payment_without_login = (formData) => {
    return this.http.post(
      this.baseUrl + `confirm_payment_without_login`,
      formData,
    );
  };

  order_history = (client_id) => {
    return this.http.get(this.baseUrl + `order_history/${client_id}`);
  };

  change_food_order = (formFata) => {
    return this.http.post(this.baseUrl + `change_food_order`, formFata);
  };

  food_listing_without_login = (formData) => {
    return this.http.post(
      this.baseUrl + `food_listing_without_login`,
      formData,
    );
  };

  select_produts_for_slider = (formFata) => {
    return this.http.post(this.baseUrl + `select_produts_for_slider`, formFata);
  };

  get_selected_products = (adminId) => {
    return this.http.get(this.baseUrl + `get_selected_products/${adminId}`);
  };

  get_member_type_admin_homepage = (formFata) => {
    return this.http.post(
      this.baseUrl + `get_member_type_admin_homepage`,
      formFata,
    );
  };

  delete_food_category = (formFata) => {
    return this.http.post(this.baseUrl + `delete_food_category`, formFata);
  };

  delete_food_subcategory = (formFata) => {
    return this.http.post(this.baseUrl + `delete_food_subcategory`, formFata);
  };

  get_all_product_banner = (adminId) => {
    return this.http.get(this.baseUrl + `get_all_product_banner/${adminId}`);
  };

  delete_product_banner = (formFata) => {
    return this.http.post(this.baseUrl + `delete_product_banner`, formFata);
  };

  add_product_banner = (formFata, options?: any) => {
    return this.http.post(
      this.baseUrl + `add_product_banner`,
      formFata,
      options,
    );
  };

  referral_reward_listing = (formFata) => {
    return this.http.post(this.baseUrl + `referral_reward_listing`, formFata);
  };

  referral_reward_detail = (formFata) => {
    return this.http.post(this.baseUrl + `referral_reward_detail`, formFata);
  };

  save_referral_remark = (formFata) => {
    return this.http.post(this.baseUrl + `save_referral_remark`, formFata);
  };

  highlight_referral_star = (formFata) => {
    return this.http.post(this.baseUrl + `highlight_referral_star`, formFata);
  };

  showHideMemberPrice = (formFata) => {
    return this.http.post(this.baseUrl + `showHideMemberPrice`, formFata);
  };

  hide_unhide_cat = (formFata) => {
    return this.http.post(this.baseUrl + `hide_unhide_cat`, formFata);
  };

  get_categories_for_setFutureSms_modal = (formFata) => {
    return this.http.post(
      this.baseUrl + `get_categories_for_setFutureSms_modal`,
      formFata,
    );
  };

  inc_dec_qty = (formFata) => {
    return this.http.post(this.baseUrl + `inc_dec_qty`, formFata);
  };

  inc_dec_qty_without_login = (formFata) => {
    return this.http.post(this.baseUrl + `inc_dec_qty_without_login`, formFata);
  };

  add_form = (formFata) => {
    return this.http.post(this.baseUrl + `add_form`, formFata);
  };

  get_forms = (formFata) => {
    return this.http.post(this.baseUrl + `get_forms`, formFata);
  };

  delete_form = (formFata) => {
    return this.http.post(this.baseUrl + `delete_form`, formFata);
  };

  get_form_detail = (formFata) => {
    return this.http.post(this.baseUrl + `get_form_detail`, formFata);
  };

  edit_form = (formFata) => {
    return this.http.post(this.baseUrl + `edit_form`, formFata);
  };

  rearrange_forms = (formFata) => {
    return this.http.post(this.baseUrl + `rearrange_forms`, formFata);
  };

  add_bottom_banner = (formFata) => {
    return this.http.post(this.baseUrl + `add_bottom_banner`, formFata);
  };

  likes_bottom_banner = (formData) => {
    return this.http.post(this.baseUrl + `likes_bottom_banner`, formData);
  };

  related_bottom_banner = (formData) => {
    return this.http.post(this.baseUrl + `related_bottom_banner`, formData);
  };

  get_bottom_banner(
    params: {
      adminId?: number;
      isAdmin?: boolean;
      page?: number;
      isPopular?: number;
      category?: string;
      hashtag?: string;
      pageSize?: number;
      search?: string;
      createdBy?: number;
    } = {},
  ) {
    const queryParams = {
      isAdmin: (params.isAdmin ?? 0).toString(),
      page: (params.page ?? 1).toString(),
      isPopular: (params.isPopular ?? 1).toString(),
      category: params.category ?? '',
      hashtag: (params.hashtag ?? '').replace('#', ''),
      pageSize: (params.pageSize ?? 5).toString(),
      search: params.search ?? '',
      createdBy: (params.createdBy ?? 0).toString(),
    };
    return this.http.get(
      this.baseUrl + `get_bottom_banner/${params.adminId ?? 0}`,
      {
        params: queryParams,
      },
    );
  }

  get_bottom_banner_by_slug = (slug) => {
    return this.http.get(this.baseUrl + `get_bottom_banner_by_slug/${slug}`);
  };

  get_one_bottom_banner = (formFata) => {
    return this.http.post(this.baseUrl + `get_one_bottom_banner`, formFata);
  };

  get_bottom_banner_for_related_by_id = (formFata) => {
    return this.http.post(
      this.baseUrl + `get_bottom_banner_for_related_by_id`,
      formFata,
    );
  };
  get_bottom_banner_for_related = (exceptId) => {
    return this.http.get(
      this.baseUrl + `get_bottom_banner_for_related?exceptId=${exceptId}`,
    );
  };

  delete_bottom_banner_for_related_by_id = (formFata) => {
    return this.http.post(
      this.baseUrl + `delete_bottom_banner_for_related_by_id`,
      formFata,
    );
  };

  edit_bottom_banner = (formFata) => {
    return this.http.post(this.baseUrl + `edit_bottom_banner`, formFata);
  };

  delete_bottom_banner = (formFata) => {
    return this.http.post(this.baseUrl + `delete_bottom_banner`, formFata);
  };

  get_pending_process_listing_new = (id) => {
    return this.http.post(this.baseUrl + `get_pending_process_listing_new`, id);
  };

  send_bday_promo_message = (formData) => {
    return this.http.post(this.baseUrl + `send_bday_promo_message`, formData);
  };

  bday_promo_redeem_complete = (formData) => {
    return this.http.post(
      this.baseUrl + `bday_promo_redeem_complete`,
      formData,
    );
  };

  get_all_values = (formData) => {
    return this.http.post(this.baseUrl + `get_all_values`, formData);
  };

  add_closing = (formData) => {
    return this.http.post(this.baseUrl + `add_closing`, formData);
  };

  closing_listing = () => {
    return this.http.get(this.baseUrl + `closing_listing`);
  };

  get_last_closing = () => {
    return this.http.get(this.baseUrl + `get_last_closing`);
  };

  upload_closing_doc = (formData) => {
    return this.http.post(this.baseUrl + `upload_closing_doc`, formData);
  };

  get_closing = (formData) => {
    return this.http.post(this.baseUrl + `get_closing`, formData);
  };

  edit_closing = (formData) => {
    return this.http.post(this.baseUrl + `edit_closing`, formData);
  };

  delete_closing = (formData) => {
    return this.http.post(this.baseUrl + `delete_closing`, formData);
  };

  save_invoice_settings = (formData) => {
    return this.http.post(this.baseUrl + `save_invoice_settings`, formData);
  };

  get_invoice_settings = () => {
    return this.http.get(this.baseUrl + `get_invoice_settings`);
  };

  add_item = (formData) => {
    return this.http.post(this.baseUrl + `add_item`, formData);
  };

  delete_item = (formData) => {
    return this.http.post(this.baseUrl + `delete_item`, formData);
  };

  view_item = (id) => {
    return this.http.get(this.baseUrl + `view_item/${id}`);
  };

  edit_item = (formData) => {
    return this.http.post(this.baseUrl + `edit_item`, formData);
  };

  lucky_draw_check_if_phone_exists = (formData) => {
    return this.http.post(
      this.baseUrl + `lucky_draw_check_if_phone_exists`,
      formData,
    );
  };

  get_lucky_draw_options = () => {
    return this.http.get(this.baseUrl + `get_lucky_draw_options`);
  };

  save_lucky_draw = (formData) => {
    return this.http.post(this.baseUrl + `save_lucky_draw`, formData);
  };

  claim_lucky_draw = (formData) => {
    return this.http.post(this.baseUrl + `claim_lucky_draw`, formData);
  };

  half_half_profit = (formData) => {
    return this.http.post(this.baseUrl + `half_half_profit`, formData);
  };

  announcement_listing = () => {
    return this.http.get(this.baseUrl + `announcement_listing`);
  };

  save_announcements = (formData) => {
    return this.http.post(this.baseUrl + `save_announcements`, formData);
  };

  add_temp_inventory_item = (formData) => {
    return this.http.post(this.baseUrl + `add_temp_inventory_item`, formData);
  };

  open_order_invoice_modal = (formData) => {
    return this.http.post(this.baseUrl + `open_order_invoice_modal`, formData);
  };

  updateTempValues = (formData) => {
    return this.http.post(this.baseUrl + `updateTempValues`, formData);
  };

  add_order_stock = (formData) => {
    return this.http.post(this.baseUrl + `add_order_stock`, formData);
  };

  confirm_final_invoice = (formData) => {
    return this.http.post(this.baseUrl + `confirm_final_invoice`, formData);
  };

  remove_temp_inventory_item = (formData) => {
    return this.http.post(
      this.baseUrl + `remove_temp_inventory_item`,
      formData,
    );
  };

  get_common_feedbacks = (formData) => {
    return this.http.post(this.baseUrl + `get_common_feedbacks`, formData);
  };

  get_url_and_sms_content = () => {
    return this.http.get(this.baseUrl + `get_url_and_sms_content`);
  };

  get_url_and_sms_content_sub = () => {
    return this.http.get(this.baseUrl + `get_url_and_sms_content_sub`);
  };

  del_url_and_sms_content = (formData) => {
    return this.http.post(this.baseUrl + `del_url_and_sms_content`, formData);
  };

  add_url_and_sms_content = (formData) => {
    return this.http.post(this.baseUrl + `add_url_and_sms_content`, formData);
  };

  add_url_and_sms_content_sub = (formData) => {
    return this.http.post(
      this.baseUrl + `add_url_and_sms_content_sub`,
      formData,
    );
  };

  edit_update_feedback_manager = (formData) => {
    return this.http.post(
      this.baseUrl + `edit_update_feedback_manager`,
      formData,
    );
  };

  signup = (formData) => {
    return this.http.post(this.baseUrl + `signup`, formData);
  };

  signup_resend_verification_email = (formData) => {
    return this.http.post(
      this.baseUrl + `signup_resend_verification_email`,
      formData,
    );
  };

  forgot_password_myvip = (formData) => {
    return this.http.post(this.baseUrl + `forgot_password_myvip`, formData);
  };

  generate_new_password = (formData) => {
    return this.http.post(this.baseUrl + `generate_new_password`, formData);
  };

  create_stripe_checkout_url = (formData) => {
    return this.http.post(
      this.baseUrl + `create_stripe_checkout_url`,
      formData,
    );
  };

  vip_token_transactions = () => {
    return this.http.get(this.baseUrl + `vip_token_transactions`);
  };

  vip_sub_transactions = (option = 1) => {
    return this.http.get(
      this.baseUrl + `vip_sub_transactions?option=` + option,
    );
  };

  vip_transactions = (show, payload = '', user_id = '', passcode = '') => {
    return this.http.get(
      this.baseUrl +
        `vip_transactions?showis=` +
        show +
        '&amount=' +
        payload +
        '&id=' +
        user_id +
        '&passcode=' +
        passcode,
      show,
    );
  };
  vip_token_transactions_subadmin = (formData) => {
    return this.http.post(
      this.baseUrl + `vip_token_transactions_subadmin`,
      formData,
    );
  };

  get_all_stripe_products = () => {
    return this.http.get(this.baseUrl + `get_all_stripe_products`);
  };

  deduct_credits = (formData) => {
    return this.http.post(this.baseUrl + `deduct_credits`, formData);
  };

  deduct_credits_transactions = (formData) => {
    return this.http.post(
      this.baseUrl + `deduct_credits_transactions`,
      formData,
    );
  };

  update_user_details = (formData) => {
    return this.http.post(this.baseUrl + `update_user_details`, formData);
  };

  get_user_details_data = () => {
    return this.http.get(this.baseUrl + `get_user_details_data`);
  };

  get_other_user_details_data = (formData) => {
    return this.http.post(
      this.baseUrl + `get_other_user_details_data`,
      formData,
    );
  };

  change_password = (formData) => {
    return this.http.post(this.baseUrl + `change_password`, formData);
  };

  // get_ip_address = () =>{
  //   return this.http.get(this.baseUrl + `get_ip_address`);
  // }

  new_all_sub_admins_list = (formData) => {
    return this.http.post(this.baseUrl + `new_all_sub_admins_list`, formData);
  };
  set_sub_admin_lock = (formData) => {
    return this.http.post(this.baseUrl + `set_sub_admin_lock`, formData);
  };
  update_other_user_details = (formData) => {
    return this.http.post(this.baseUrl + `update_other_user_details`, formData);
  };

  add_feedback_url_name = (formData) => {
    return this.http.post(this.baseUrl + `add_feedback_url_name`, formData);
  };

  get_feedback_url_name = (formData) => {
    return this.http.post(this.baseUrl + `get_feedback_url_name`, formData);
  };

  get_feedback_manager_url = () => {
    return this.http.get(this.baseUrl + `get_feedback_manager_url`);
  };

  get_specific_feedback_manager_url = (id) => {
    return this.http.get(
      this.baseUrl + `get_specific_feedback_manager_url/${id}`,
    );
  };

  block_unblock_user = (formData) => {
    return this.http.post(this.baseUrl + `block_unblock_user`, formData);
  };

  user_login_history = (formData) => {
    return this.http.post(this.baseUrl + `user_login_history`, formData);
  };

  deleteUser = (formData) => {
    return this.http.post(this.baseUrl + `delete_user`, formData);
  };

  get_subAdminName = (formData) => {
    return this.http.post(this.baseUrl + `get_subAdminName`, formData);
  };

  reviewImageUploadForm = (formData) => {
    return this.http.post(this.baseUrl + `reviewImageUploadForm`, formData);
  };

  feedbackManagerdata = (formData) => {
    return this.http.post(this.baseUrl + `feedbackManagerData`, formData);
  };
  delete_feedback_url_name = (id) => {
    return this.http.get(this.baseUrl + `delete_feedback_url_name/${id}`);
  };
  optional_url = (data) => {
    return this.http.post(this.baseUrl + `optional_url`, data);
  };
  get_feedbackimagedata = (id) => {
    return this.http.get(this.baseUrl + `get_feedbackimagedata/${id}`);
  };

  add_feedback_subadmin_google = (formData) => {
    return this.http.post(
      this.baseUrl + `add_feedback_subadmin_google`,
      formData,
    );
  };

  get_feedback_subadmin_google = (params) => {
    return this.http.get(
      this.baseUrl + `get_feedback_subadmin_google/${params.id}`,
      { params: params },
    );
  };
  get_feedback_subadmin_google_detail = (id) => {
    return this.http.get(
      this.baseUrl + `get_feedback_subadmin_google_detail/${id}`,
    );
  };

  reviewImageUploadForm_2 = (formData) => {
    return this.http.post(this.baseUrl + `reviewImageUploadForm_2`, formData);
  };

  get_feedbackimagedata_2 = (id) => {
    return this.http.get(this.baseUrl + `get_feedbackimagedata_2/${id}`);
  };

  get_feedback_subadmin_google_2 = (id) => {
    return this.http.get(this.baseUrl + `get_feedback_subadmin_google_2/${id}`);
  };

  get_other_admin_All_Req_2() {
    return this.http.get(this.baseUrl + `get_other_admin_All_Req_2`);
  }

  add_manual_review_user_2(formData) {
    return this.http.post(this.baseUrl + `add_manual_review_user_2`, formData);
  }

  edit_review_user_2(formData) {
    return this.http.post(this.baseUrl + `edit_review_user_2`, formData);
  }

  edit_feedback_subadmin_google_2 = (id) => {
    return this.http.get(
      this.baseUrl + `edit_feedback_subadmin_google_2/${id}`,
    );
  };

  update_edit_google_feedbacks_2 = (formData, id) => {
    return this.http.post(
      this.baseUrl + `update_edit_google_feedbacks_2/${id}`,
      formData,
    );
  };

  update_circle_2 = (formData, id) => {
    return this.http.post(this.baseUrl + `update_circle_2/${id}`, formData);
  };

  getnameByAdminOther_2 = (sub_admin_id) => {
    return this.http.get(
      this.baseUrl + `getnameByAdminOther_2?sub_admin_id=${sub_admin_id}`,
    );
  };

  verify_feedback_subadmin_google_2 = (id) => {
    return this.http.get(
      this.baseUrl + `verify_feedback_subadmin_google_2/${id}`,
    );
  };

  getSmsFeedback_2 = (
    id: number,
  ): Observable<GetFeedbackMessageSuccessResponse> => {
    return this.http.get<GetFeedbackMessageSuccessResponse>(
      `${this.baseUrl}getFeedBackMessages_2/${id}`,
    );
  };

  saveFeedbackApproval_2 = (formData) => {
    return this.http.post(this.baseUrl + `saveFeedbackApproval_2`, formData);
  };

  saveFeedbackPayment_2 = (formData) => {
    return this.http.post(this.baseUrl + `saveFeedbackPayment_2`, formData);
  };

  saveFeedbackPaymentClient_2 = (formData) => {
    return this.http.post(
      this.baseUrl + `saveFeedbackPaymentClient_2`,
      formData,
    );
  };

  get_feedback_subadmin_google_detail_2 = (id) => {
    return this.http.get(
      this.baseUrl + `get_feedback_subadmin_google_detail_2/${id}`,
    );
  };

  get_feedback_subadmin_google_detail_3 = (id) => {
    return this.http.get(
      this.baseUrl + `get_feedback_subadmin_google_detail_3/${id}`,
    );
  };

  reviewImageUploadForm_3 = (formData) => {
    return this.http.post(this.baseUrl + `reviewImageUploadForm_3`, formData);
  };

  get_feedbackimagedata_3 = (id) => {
    return this.http.get(this.baseUrl + `get_feedbackimagedata_3/${id}`);
  };

  get_feedback_subadmin_google_3 = (id) => {
    return this.http.get(this.baseUrl + `get_feedback_subadmin_google_3/${id}`);
  };

  get_other_admin_All_Req_3() {
    return this.http.get(this.baseUrl + `get_other_admin_All_Req_3`);
  }

  add_manual_review_user_3(formData) {
    return this.http.post(this.baseUrl + `add_manual_review_user_3`, formData);
  }

  edit_review_user_3(formData) {
    return this.http.post(this.baseUrl + `edit_review_user_3`, formData);
  }

  edit_feedback_subadmin_google_3 = (id) => {
    return this.http.get(
      this.baseUrl + `edit_feedback_subadmin_google_3/${id}`,
    );
  };

  update_edit_google_feedbacks_3 = (formData, id) => {
    return this.http.post(
      this.baseUrl + `update_edit_google_feedbacks_3/${id}`,
      formData,
    );
  };

  update_circle_3 = (formData, id) => {
    return this.http.post(this.baseUrl + `update_circle_3/${id}`, formData);
  };

  getnameByAdminOther_3 = (sub_admin_id) => {
    return this.http.get(
      this.baseUrl + `getnameByAdminOther_3?sub_admin_id=${sub_admin_id}`,
    );
  };

  verify_feedback_subadmin_google_3 = (id) => {
    return this.http.get(
      this.baseUrl + `verify_feedback_subadmin_google_3/${id}`,
    );
  };

  getSmsFeedback_3 = (
    id: number,
  ): Observable<GetFeedbackMessageSuccessResponse> => {
    return this.http.get<GetFeedbackMessageSuccessResponse>(
      `${this.baseUrl}getFeedBackMessages_3/${id}`,
    );
  };

  saveFeedbackApproval_3 = (formData) => {
    return this.http.post(this.baseUrl + `saveFeedbackApproval_3`, formData);
  };

  saveFeedbackPayment_3 = (formData) => {
    return this.http.post(this.baseUrl + `saveFeedbackPayment_3`, formData);
  };

  saveFeedbackPaymentClient_3 = (formData) => {
    return this.http.post(
      this.baseUrl + `saveFeedbackPaymentClient_3`,
      formData,
    );
  };

  getUserShareReview = (phone) => {
    return this.http.get(this.baseUrl + `getUserShareReview/${phone}`);
  };
  getClientShareReview = (clientId) => {
    return this.http.get(this.baseUrl + `getClientShareReview/${clientId}`);
  };
  get_admin_All_Req() {
    return this.http.get(this.baseUrl + `get_admin_All_Req`);
  }

  get_admin_All_Data() {
    return this.http.get(this.baseUrl + `get_admin_All_Data`);
  }

  get_other_admin_All_Req() {
    return this.http.get(this.baseUrl + `get_other_admin_All_Req`);
  }

  get_other_admin_All_Data() {
    return this.http.get(this.baseUrl + `get_other_admin_All_Data`);
  }
  add_review_user(formData) {
    return this.http.post(this.baseUrl + `add_review_user`, formData);
  }

  edit_review_user(formData) {
    return this.http.post(this.baseUrl + `edit_review_user`, formData);
  }

  edit_feedback_subadmin_google = (id) => {
    return this.http.get(this.baseUrl + `edit_feedback_subadmin_google/${id}`);
  };
  update_edit_google_feedbacks = (formData, id) => {
    return this.http.post(
      this.baseUrl + `update_edit_google_feedbacks/${id}`,
      formData,
    );
  };

  update_google_name = (formData, id) => {
    return this.http.post(this.baseUrl + `update_google_name/${id}`, formData);
  };

  update_circle = (formData, id) => {
    return this.http.post(this.baseUrl + `update_circle/${id}`, formData);
  };

  update_circle_client_url = (formData, id) => {
    return this.http.post(
      this.baseUrl + `update_circle_client_url/${id}`,
      formData,
    );
  };

  addnameByAdmin = (formData) => {
    return this.http.post(this.baseUrl + `addnameByAdmin`, formData);
  };
  updateAmountByAdmin = (formData) => {
    return this.http.post(this.baseUrl + `updateAmountByAdmin`, formData);
  };
  deletenameByAdmin = (id) => {
    return this.http.get(this.baseUrl + `deletenameByAdmin/${id}`);
  };

  getnameByAdmin = () => {
    return this.http.get(this.baseUrl + `getnameByAdmin`);
  };
  getnameByAdminOther = (sub_admin_id) => {
    return this.http.get(
      this.baseUrl + `getnameByAdminOther?sub_admin_id=${sub_admin_id}`,
    );
  };

  verify_feedback_subadmin_google = (id) => {
    return this.http.get(
      this.baseUrl + `verify_feedback_subadmin_google/${id}`,
    );
  };

  hideGoogelreview = (id, status) => {
    return this.http.get(
      this.baseUrl + `hideGoogelreview?id=${id}&status=${status}`,
    );
  };

  refreshGoogleData = (place_id) => {
    // refreshGoogleData(place_id: string): Observable<any> {
    return this.http.get(
      this.baseUrl + `refreshGoogleApiData?place_id=${place_id}`,
    );
  };

  update_google_review_from_google = (formData) => {
    return this.http.post(
      this.baseUrl + `update_google_review_from_google`,
      formData,
    );
  };

  getSmsFeedback = (
    id: number,
  ): Observable<GetFeedbackMessageSuccessResponse> => {
    return this.http.get<GetFeedbackMessageSuccessResponse>(
      `${this.baseUrl}getFeedBackMessages/${id}`,
    );
  };

  notification_listing = () => {
    return this.http.get(this.baseUrl + `notification_listing`);
  };

  staff_listing = (formData) => {
    return this.http.post(this.baseUrl + `staff_listing`, formData);
  };

  review_information = (formData) => {
    return this.http.post(this.baseUrl + `review_information`, formData);
  };

  review_information_staff = (formData) => {
    return this.http.post(this.baseUrl + `review_information_staff`, formData);
  };

  downloadStripeReceipt = (id) => {
    return this.http.get(this.baseUrl + `downloadStripeReceipt/${id}`);
  };

  addMassMessage = (formData) => {
    return this.http.post(this.baseUrl + `mass_message`, formData);
  };

  saveFeedbackApproval = (formData) => {
    return this.http.post(this.baseUrl + `saveFeedbackApproval`, formData);
  };

  saveFeedbackPayment = (formData) => {
    return this.http.post(this.baseUrl + `saveFeedbackPayment`, formData);
  };

  saveFeedbackPaymentClient = (formData) => {
    return this.http.post(this.baseUrl + `saveFeedbackPaymentClient`, formData);
  };

  getMassMessage = () => {
    return this.http.get(this.baseUrl + `mass_message`);
  };

  readMassMessage = (formData) => {
    return this.http.post(this.baseUrl + `read_mass_message`, formData);
  };

  pendingMassMessage = (formData) => {
    return this.http.post(this.baseUrl + `pending_mass_message`, formData);
  };

  updateTransactionUser = (formData) => {
    return this.http.post(this.baseUrl + `updateTransactionUser`, formData);
  };

  saveUserEmail = (formData) => {
    return this.http.post(this.baseUrl + `saveuseremail`, formData);
  };

  sendEmailtoAll = (formData) => {
    return this.http.post(this.baseUrl + `sendmailtoall`, formData);
  };

  SubAdminEmailList = () => {
    return this.http.get(this.baseUrl + `SubAdminEmailList`);
  };

  clientUrlPayment = (formData) => {
    return this.http.post(
      this.baseUrl + `clientUrlPayment`,
      formData,
      this.header.formheaderClientUrl(),
    );
  };

  purchasedSlots = (formData) => {
    return this.http.post(this.baseUrl + `purchasedSlots`, formData);
  };

  slotTransactions = () => {
    return this.http.get(this.baseUrl + `slotTransactions`);
  };

  get_google_name_link = (id) => {
    return this.http.get(this.baseUrl + `get_google_name_link/${id}`);
  };

  updateSliderText = (formData) => {
    return this.http.post(this.baseUrl + `updateSliderText`, formData);
  };

  updateClientText = (formData) => {
    return this.http.post(this.baseUrl + `updateClientText`, formData);
  };

  addOrUpdateSearchMap = (formData) => {
    return this.http.post(this.baseUrl + `addSearchMap`, formData);
  };

  getSearchMaps = () => {
    return this.http.get(this.baseUrl + `getSearchMaps`);
  };

  // ------------- Marketplace ------------------------

  marketplace_categories = () => {
    return this.http.get(this.baseUrl + `marketplace_categories`);
  };

  marketplace_all_subcategories = () => {
    return this.http.get(this.baseUrl + `marketplace_all_subcategories`);
  };

  marketplace_subcategories = (formData) => {
    return this.http.post(this.baseUrl + `marketplace_subcategories`, formData);
  };

  marketplace_favorite_product = (formData) => {
    return this.http.post(
      this.baseUrl + `marketplace_favorite_product`,
      formData,
    );
  };

  marketplace_favorite_product_status = (formData) => {
    return this.http.post(
      this.baseUrl + `marketplace_favorite_product_status`,
      formData,
    );
  };

  marketplace_favorite_product_profile = (formData) => {
    return this.http.post(
      this.baseUrl + `marketplace_favorite_product_profile`,
      formData,
    );
  };

  marketplace_food_listing = (formData) => {
    return this.http.get(this.baseUrl + `marketplace_food_listing`, {
      params: formData,
    });
  };

  marketplace_featured_products = () => {
    return of([
      {
        id: 431,
        adminId: 206,
        categoryId: 51,
        subCategoryId: 101,
        name: 'Absolute Repair Haircare Kit',
        description:
          'Hair fall? Bald spots? Itchy scalp? Dandruff? Hair thinning? We got you. All problems, one solution, try our Mars Absolute Repair Haircare kit today.',
        chat_url: null,
        unit: '',
        seller_info: null,
        mrp: 45,
        memberPrice: 30,
        costPrice: 0,
        maxQty: 999,
        status: 1,
        isDeleted: 0,
        indexx: 8,
        outOfStockAll: 0,
        percent_value: 0,
        percent_type: 0,
        special_category: null,
        icons: null,
        created: 1709908935,
        updated: 1709908935,
        foodSpecs: [
          {
            id: 4530,
            foodId: 431,
            nKey: '',
            key: '13',
            value: 'Shampoo Pack',
            costPrice: '',
            outOfStockSingle: 0,
            created: 1709908935,
            updated: 1709908935,
          },
        ],
        foodImages: [
          {
            id: 769,
            foodId: 431,
            image: 'public/images/food/1709908934757753827.png',
            imageAccessor: 'image1',
            created: 1709908936,
            updated: 1709908936,
          },
        ],
      },
      {
        id: 425,
        adminId: 206,
        categoryId: 51,
        subCategoryId: 101,
        name: 'Amino Acid Shampoo ',
        description:
          'Roméro shampoo uses amino acid-based ingredients that?are gentle to both hair and scalp.\r\nAmino acid shampoo refers to shampoos that contain amino acid-based cleansing ingredients.\r\nThe human body, including skin, nails, and hair, is made of proteins composed of numerous amino acids.\r\nSince these ingredients are originally present in the human body, amino acid shampoos help maintain the health of the scalp and hair. ',
        chat_url: null,
        unit: '',
        seller_info: null,
        mrp: 20,
        memberPrice: 15,
        costPrice: 0,
        maxQty: 999,
        status: 1,
        isDeleted: 0,
        indexx: 2,
        outOfStockAll: 0,
        percent_value: 0,
        percent_type: 0,
        special_category: null,
        icons: null,
        created: 1709907453,
        updated: 1709907453,
        foodSpecs: [
          {
            id: 4524,
            foodId: 425,
            nKey: '',
            key: '13',
            value: 'Acid Shampoo ',
            costPrice: '',
            outOfStockSingle: 0,
            created: 1709907453,
            updated: 1709907453,
          },
        ],
        foodImages: [
          {
            id: 758,
            foodId: 425,
            image: 'public/images/food/1709907453015947210.png',
            imageAccessor: 'image1',
            created: 1709907453,
            updated: 1709907453,
          },
        ],
      },
      {
        id: 432,
        adminId: 206,
        categoryId: 51,
        subCategoryId: 101,
        name: 'Essential Hair Growth Kit',
        description:
          'Hair fall is caused by many reasons. A few of them include increased DHT levels and decreased blood circulation to the scalp and hair roots. Block DHT and improve blood circulation to the scalp by usingMinoxidil solutionand Fin. 1 mg tablets.',
        chat_url: null,
        unit: '',
        seller_info: null,
        mrp: 33,
        memberPrice: 28,
        costPrice: 0,
        maxQty: 999,
        status: 1,
        isDeleted: 0,
        indexx: 9,
        outOfStockAll: 0,
        percent_value: 0,
        percent_type: 0,
        special_category: null,
        icons: null,
        created: 1709909039,
        updated: 1709909039,
        foodSpecs: [
          {
            id: 4531,
            foodId: 432,
            nKey: '',
            key: '13',
            value: 'Mini Pack',
            costPrice: '',
            outOfStockSingle: 0,
            created: 1709909039,
            updated: 1709909039,
          },
        ],
        foodImages: [
          {
            id: 771,
            foodId: 432,
            image: 'public/images/food/1709909038830207110.png',
            imageAccessor: 'image1',
            created: 1709909040,
            updated: 1709909040,
          },
        ],
      },
      {
        id: 581,
        adminId: 193,
        categoryId: 84,
        subCategoryId: 186,
        name: 'Weekday Lunch Menu',
        description:
          'AVAILABLE FROM 11AM TO 3PM MONDAYS TO FRIDAYS *EXCEPT ON PUBLIC HOLIDAYS*\r\n\r\nPAIRED WITH HOMEMADE ICED TEA or BLACK COFFEE. \r\n\r\nExplore our délicieux "Menu du Déjeuner"\r\n\r\na special lunch selection exclusively available on weekdays.\r\nSavor exquisite flavors in every bite!',
        chat_url: null,
        unit: '',
        seller_info: null,
        mrp: 0,
        memberPrice: 16,
        costPrice: 0,
        maxQty: 99,
        status: 1,
        isDeleted: 0,
        indexx: 2,
        outOfStockAll: 0,
        percent_value: 0,
        percent_type: 0,
        special_category: null,
        icons: null,
        created: 1715228993,
        updated: 1715228993,
        foodSpecs: [
          {
            id: 5363,
            foodId: 581,
            nKey: 'Parma ham or smoked salmon served with cherry tomatoes, mixed greens',
            key: '16',
            value: 'CHEZ SUZETTE HOUSE SALAD',
            costPrice: '',
            outOfStockSingle: 0,
            created: 1715229186,
            updated: 1715229186,
          },
          {
            id: 5364,
            foodId: 581,
            nKey: 'Premium tagliatelle, button mushrooms and edamame sautéed with garlic and chilli flakes, extra virgin olive oil and dried parsley',
            key: '18',
            value: 'MUSHROOM TAGLIATELLE',
            costPrice: '',
            outOfStockSingle: 0,
            created: 1715229186,
            updated: 1715229186,
          },
          {
            id: 5365,
            foodId: 581,
            nKey: 'Seared grass-fed Black Angus ribeye (200g) served with fries and mushroom sauce',
            key: '24',
            value: 'STEAK FRITES',
            costPrice: '',
            outOfStockSingle: 0,
            created: 1715229186,
            updated: 1715229186,
          },
          {
            id: 5366,
            foodId: 581,
            nKey: 'Our own version of creme caramel',
            key: '5',
            value: 'LECHE FLAN',
            costPrice: '',
            outOfStockSingle: 0,
            created: 1715229186,
            updated: 1715229186,
          },
        ],
        foodImages: [
          {
            id: 1317,
            foodId: 581,
            image: 'public/images/food/1715229186240897755.png',
            imageAccessor: 'image1',
            created: 1715229186,
            updated: 1715229186,
          },
        ],
      },
      {
        id: 624,
        adminId: 193,
        categoryId: 84,
        subCategoryId: 186,
        name: 'BRUNCH MENU',
        description: '-',
        chat_url: null,
        unit: '',
        seller_info: null,
        mrp: 22,
        memberPrice: 22,
        costPrice: 0,
        maxQty: 999,
        status: 1,
        isDeleted: 0,
        indexx: 3,
        outOfStockAll: 0,
        percent_value: 0,
        percent_type: 0,
        special_category: '',
        icons: null,
        created: 1715586951,
        updated: 1715586951,
        foodSpecs: [
          {
            id: 5447,
            foodId: 624,
            nKey: '',
            key: '22',
            value: 'SCRAMBLED EGG AND SMOKED SALMON Croissant Sandwich',
            costPrice: '',
            outOfStockSingle: 0,
            created: 1715586951,
            updated: 1715586951,
          },
          {
            id: 5448,
            foodId: 624,
            nKey: '',
            key: '26',
            value: 'EGGS BENEDICT',
            costPrice: '',
            outOfStockSingle: 0,
            created: 1715586951,
            updated: 1715586951,
          },
          {
            id: 5449,
            foodId: 624,
            nKey: '',
            key: '22',
            value: 'Avocado Toast',
            costPrice: '',
            outOfStockSingle: 0,
            created: 1715586951,
            updated: 1715586951,
          },
        ],
        foodImages: [
          {
            id: 1586,
            foodId: 624,
            image: 'public/images/food/1715586951501243639.png',
            imageAccessor: 'image1',
            created: 1715586952,
            updated: 1715586952,
          },
        ],
      },
    ]);
  };

  admin_marketplace_food_listing = (formData) => {
    return this.http.post(
      this.baseUrl + `adminMarketplaceFoodListing`,
      formData,
    );
  };

  admin_marketplace_food_listing_email = (formData) => {
    return this.http.post(
      this.baseUrl + `adminMarketplaceFoodListingEmail`,
      formData,
    );
  };

  add_product_to_marketplace = (formData) => {
    return this.http.post(
      this.baseUrl + `add_product_to_marketplace`,
      formData,
    );
  };

  set_marketplace_featured_product = (formData) => {
    return this.http.post(
      this.baseUrl + `set_marketplace_featured_product`,
      formData,
    );
  };

  marketplace_forum_shop = (id: any) => {
    return this.http.get(this.baseUrl + `forumShop?shopId=${id}`);
  };

  marketplace_forum_shop_fetch_by_shopId(shopId) {
    return this.http.get(this.baseUrl + `forumList`, {
      params: {
        shopId,
      },
    });
  }

  marketplace_forum_shop_fetch = (
    id?: any,
    page: number = 1,
    categoryId: any = '',
    mainCategories: any = [],
    isPinned: boolean = false,
    search: string = '',
    limit: string | number = 'any',
  ) => {
    return this.http.get(this.baseUrl + `forumList`, {
      params: {
        shopId: id,
        isPinned: isPinned,
        categoryId: categoryId,
        page: page,
        categories: JSON.stringify(mainCategories),
        search: search,
        limit,
      },
    });
  };

  forum_find = (uuid: string) => {
    return this.http.get(`${this.baseUrl}forum/${uuid}`);
  };

  forum_category_fetch = (page: number = 1) => {
    return this.http.get(this.baseUrl + `forumCategoryList?page=${page}`);
  };

  forum_category_store = (formData) => {
    return this.http.post(this.baseUrl + `forumCategory`, formData);
  };

  forum_category_delete = (id: any) => {
    return this.http.delete(this.baseUrl + `forumCategory/${id}`);
  };
  forum_pin = (id: any) => {
    return this.http.post(this.baseUrl + `forumPinned/${id}`, {});
  };
  forum_likes = (formData) => {
    return this.http.post(this.baseUrl + `forumLikes`, formData);
  };

  forum_mute = (formData) => {
    return this.http.post(this.baseUrl + `forumMute`, formData);
  };

  marketplace_forum_shop_fetch_reply = (
    id: any,
    page: number = 1,
    withChildReply = false,
    forAsk: boolean = false,
    limit: string | number = 'none',
  ) => {
    const type = forAsk ? 'askId' : 'forumId';
    return this.http.get(
      this.baseUrl +
        `forumReplyList?${type}=${id}&page=${page}&withChildReply=${withChildReply}&limit=${limit}`,
    );
  };

  marketplace_forum_shop_delete = (id: any) => {
    return this.http.delete(this.baseUrl + `forum/${id}`);
  };

  marketplace_forum_shop_delete_reply = (id: any) => {
    return this.http.delete(this.baseUrl + `forumReply/${id}`);
  };

  marketplace_forum_shop_store = (formData) => {
    return this.http.post(this.baseUrl + `forumMessage`, formData);
  };

  marketplace_forum_shop_store_reply = (formData) => {
    return this.http.post(this.baseUrl + `forumReplyMessage`, formData);
  };

  add_news_to_forum = (formData) => {
    return this.http.post(this.baseUrl + `forum/add-news-to-forum`, formData);
  };

  remove_news_from_forum = (formData) => {
    return this.http.post(
      this.baseUrl + `forum/remove-news-from-forum`,
      formData,
    );
  };

  get_news_by_forum_id = (forumId: any) => {
    return this.http.get(
      this.baseUrl + `forum/get-news-by-forum-id/${forumId}`,
    );
  };

  giveaway_fetch = ({ isAll = false, subRegion = '' }) => {
    return this.http.get(this.baseUrl + `giveaway`, {
      params: {
        isAll,
        subRegion,
      },
    });
  };

  giveaway_notification_fetch = () => {
    return this.http.get(this.baseUrl + `giveaway/notification`);
  };

  giveaway_notification_delete = () => {
    return this.http.post(this.baseUrl + `giveaway/notification/delete`, {});
  };

  giveaway_find = (id) => {
    return this.http.get(this.baseUrl + `giveaway/${id}`);
  };
  giveaway_store = (formData) => {
    return this.http.post(this.baseUrl + `giveaway`, formData);
  };
  giveaway_participate = (formData) => {
    return this.http.post(this.baseUrl + `giveaway/participate`, formData);
  };
  giveaway_delete = (id: any) => {
    return this.http.delete(this.baseUrl + `giveaway/${id}`);
  };

  giveaway_survey_fetch = (giveawayId, showAll = false) => {
    return this.http.get(
      this.baseUrl +
        `giveaway/giveaway-survey?giveawayId=${giveawayId}&showAll=${showAll}`,
    );
  };

  giveaway_survey_store = (formData) => {
    return this.http.post(this.baseUrl + `giveaway/giveaway-survey`, formData);
  };

  giveaway_survey_publish = (formData) => {
    return this.http.post(
      this.baseUrl + `giveaway/giveaway-survey-publish`,
      formData,
    );
  };

  giveaway_survey_participate = (formData) => {
    return this.http.post(
      this.baseUrl + `giveaway/giveaway-survey-participate`,
      formData,
    );
  };

  giveaway_survey_delete = (id: any) => {
    return this.http.delete(this.baseUrl + `giveaway/giveaway-survey/${id}`);
  };

  giveaway_likes = (formData) => {
    return this.http.post(this.baseUrl + `giveaway/likes`, formData);
  };

  giveaway_addEmail = (formData) => {
    return this.http.post(this.baseUrl + `giveaway/add-email`, formData);
  };

  giveaway_sendNotifyMail = (formData) => {
    return this.http.post(this.baseUrl + `giveaway/send-notify-mail`, formData);
  };

  addOpenEndedAnswer = ({ pollId, answer = '', comparableAns = '' }) => {
    return this.http.post(this.baseUrl + 'addOpenEndedAnswer', {
      pollId,
      answer,
      comparableAns,
    });
  };
  getOpenEndedAnswersForPoll = (pollId) => {
    return this.http.get(
      this.baseUrl + 'getOpenEndedAnswersForPoll' + '/' + pollId,
    ) as Observable<ApiResponse>;
  };
  getPopularProductsBasedOnPoll = (payload) => {
    return this.http.post(
      `${this.baseUrl}getPopularProductsBasedOnPoll`,
      payload,
    ) as any as Observable<ApiResponse>;
  };
  poll_fetch = ({
    isAll = false,
    productId = null,
    fetchCategoryOnly = false,
    categoryId = null,
    subRegionId = null,
  }) => {
    //console.log('params are ', {isAll, productId, fetchCategoryOnly, categoryId, subRegionId})
    const urlParams = new URLSearchParams();
    urlParams.set('isAll', isAll + '');
    if (categoryId) {
      urlParams.set('categoryId', categoryId);
    }
    if (productId) {
      urlParams.set('productId', productId);
    }
    if (subRegionId) {
      urlParams.set('subRegionId', subRegionId);
    }
    if (fetchCategoryOnly) {
      urlParams.set('fetchCategoryOnly', fetchCategoryOnly + '');
    }
    return this.http.get(this.baseUrl + `poll?${urlParams.toString()}`);
  };

  poll_store = (formData) => {
    return this.http.post(this.baseUrl + `poll`, formData);
  };
  poll_option_store = (formData) => {
    return this.http.post(this.baseUrl + `pollOption`, formData);
  };
  poll_check = (formData) => {
    return this.http.post(this.baseUrl + `pollCheck`, formData);
  };
  poll_likes = (formData) => {
    return this.http.post(this.baseUrl + `pollLikes`, formData);
  };

  poll_delete = (id: any) => {
    return this.http.delete(this.baseUrl + `poll/${id}`);
  };

  bulletin_fetch = (isAll = false) => {
    return this.http.get(this.baseUrl + `bulletin/fetch`);
  };

  bulletin_store = (formData) => {
    return this.http.post(this.baseUrl + `bulletin/store`, formData);
  };

  bulletin_likes = (formData) => {
    return this.http.post(this.baseUrl + `bulletin/likes`, formData);
  };

  bulletin_delete(id: number) {
    return this.http.delete(`${this.baseUrl}bulletin/delete/${id}`);
  }

  getSearchMapForm = () => {
    return this.http.get(this.baseUrl + `getSearchMapForm`);
  };

  updateMapSearchForm = (formData) => {
    return this.http.post(this.baseUrl + `updateMapSearchForm`, formData);
  };
  // campaigns data

  addOrUpdateCompaigns = (formData) => {
    return this.http.post(this.baseUrl + `addCampaigns`, formData);
  };

  getCompaigns = () => {
    return this.http.get(this.baseUrl + `getCampaigns`);
  };

  getCampaignsForm = () => {
    return this.http.get(this.baseUrl + `getCampaignsForm`);
  };

  updateCampaignsForm = (formData) => {
    return this.http.post(this.baseUrl + `updateCampaignsForm`, formData);
  };

  subadmin_order_listing = () => {
    return this.http.get(this.baseUrl + `subadmin_order_listing`);
  };

  shop_business_fetch = (params = {}) => {
    return this.http.get(this.baseUrl + `shop-business/fetch`, {
      params: params,
    });
  };

  shop_business_delete = (id) => {
    return this.http.post(this.baseUrl + `shop-business/delete/${id}`, {});
  };

  shop_business_view = (id) => {
    return this.http.get(this.baseUrl + `shop-business/view/${id}`);
  };

  shop_business_store = (formData) => {
    return this.http.post(this.baseUrl + `shop-business/store`, formData);
  };

  shop_business_add_news = (formData) => {
    return this.http.post(this.baseUrl + `shop-business/add_news`, formData);
  };

  shop_business_get_news = (id: any = null) => {
    return this.http.get(this.baseUrl + `shop-business/get_news`, {
      params: {
        id: id,
      },
    });
  };

  shop_business_delete_news = (id) => {
    return this.http.post(this.baseUrl + `shop-business/delete_news/${id}`, {});
  };

  survey_fetch = () => {
    return this.http.get(this.baseUrl + `survey/fetch`);
  };

  survey_add = (formData) => {
    return this.http.post(this.baseUrl + `survey/add`, formData);
  };

  survey_delete = (id: any) => {
    return this.http.post(this.baseUrl + `survey/delete/${id}`, {});
  };

  change_order_status = (formData) => {
    return this.http.post(this.baseUrl + `change_order_status`, formData);
  };

  save_shop_profile = (formData) => {
    return this.http.post(this.baseUrl + `save_shop_profile`, formData);
  };

  get_shop_profile_data = (adminId = null) => {
    return this.http.get(this.baseUrl + `get_shop_profile_data`, {
      params: {
        adminId: adminId,
      },
    });
  };

  get_shop_profile_data_without_login = (client_id) => {
    return this.http.get(
      this.baseUrl + `get_shop_profile_data_without_login/${client_id}`,
    );
  };

  get_marketplace_referral_store_link = (foodId) => {
    return this.http.get(
      this.baseUrl + `get_marketplace_referral_store_link/${foodId}`,
    );
  };

  read_shop_summaries = (formData) => {
    return this.http.post(this.baseUrl + `get_shop_summaries`, formData);
  };

  add_product_review = (formData) => {
    return this.http.post(this.baseUrl + `add_product_review`, formData);
  };
  get_product_reviews = (formData) => {
    return this.http.post(this.baseUrl + `get_product_reviews`, formData);
  };

  sendSmsFeedback = (formData, desc, review_link) => {
    var data = {
      messaging_product: 'whatsapp',
      to: formData.phone,
      type: 'template',
      template: {
        name: 'myvip_2',
        language: {
          code: 'en_US',
        },
        components: [
          {
            type: 'body',
            parameters: [
              {
                type: 'text',
                text: desc,
              },
              {
                type: 'text',
                text: review_link,
              },
            ],
          },
        ],
      },
    };
    return new Observable((observer) => {
      this.http.post(environment.whtsappCloudUrl, data).subscribe(
        (response) => {
          //console.log('response', response);
          this.http
            .post(`${this.baseUrl}saveFeedback`, {
              gfbid: formData.gfbid,
              phone: formData.phone,
              response: JSON.stringify(response),
              status: 'Success',
            })
            .subscribe((res) => {
              observer.next(response);
              observer.complete();
            });
        },
        (err) => {
          this.http
            .post(`${this.baseUrl}saveFeedback`, {
              gfbid: formData.gfbid,
              phone: formData.phone,
              response: JSON.stringify(err),
              status: 'Failure',
            })
            .subscribe((res) => {
              observer.error(err);
              observer.complete();
            });
        },
      );
    });

    //return this.http.post(this.baseUrl + `sendfeedback`, formData);
  };

  sendSmsFeedback_additional = (
    formData,
    desc,
    review_link,
    image_upload_link,
    user_share_review_link,
  ) => {
    var data = {
      messaging_product: 'whatsapp',
      to: formData.phone,
      type: 'template',
      template: {
        name: 'myvip_2',
        // name: 'myvip_review_',
        language: {
          code: 'en_US',
        },
        components: [
          {
            type: 'body',
            parameters: [
              {
                type: 'text',
                // text: `Review: ${desc}`,
                text: desc,
              },
              {
                type: 'text',
                text: `${review_link}`,
              },
              {
                type: 'text',
                text: `${image_upload_link}`,
              },
              {
                type: 'text',
                text: `${user_share_review_link}`,
              },
            ],
          },
        ],
      },
    };
    //console.log(data, '----message data----');

    return new Observable((observer) => {
      return this.http
        .post(`${this.baseUrl}saveFeedback`, {
          gfbid: formData.gfbid,
          phone: formData.phone,
          name: formData.name,
          is_verify: 1, //need to update 0 in db
          response: 'Success',
          status: 'Failure',
        })
        .subscribe((res) => {
          observer.next(res);
          observer.complete();
        });
      this.http.post(environment.whtsappCloudUrl, data).subscribe(
        (response) => {
          //console.log('response', response);
          this.http
            .post(`${this.baseUrl}saveFeedback`, {
              gfbid: formData.gfbid,
              name: formData.name,
              google_name: formData.google_name,
              phone: formData.phone,
              amount: formData.amount,
              nameId: formData.nameId,
              is_verify: 1, //need to update 0 in db
              response: JSON.stringify(response),
              status: 'Success',
            })
            .subscribe((res) => {
              observer.next(response);
              observer.complete();
            });
        },
        (err) => {
          this.http
            .post(`${this.baseUrl}saveFeedback`, {
              gfbid: formData.gfbid,
              phone: formData.phone,
              name: formData.name,
              is_verify: 1, //need to update 0 in db
              response: JSON.stringify(err),
              status: 'Failure',
            })
            .subscribe((res) => {
              observer.error(err);
              observer.complete();
            });
        },
      );
    });

    //return this.http.post(this.baseUrl + `sendfeedback`, formData);
  };

  sendSmsFeedback_additional_2 = (
    formData,
    desc,
    review_link,
    image_upload_link,
    user_share_review_link,
  ) => {
    var data = {
      messaging_product: 'whatsapp',
      to: formData.phone,
      type: 'template',
      template: {
        name: 'myvip_2',
        // name: 'myvip_review_',
        language: {
          code: 'en_US',
        },
        components: [
          {
            type: 'body',
            parameters: [
              {
                type: 'text',
                // text: `Review: ${desc}`,
                text: desc,
              },
              {
                type: 'text',
                text: `${review_link}`,
              },
              {
                type: 'text',
                text: `${image_upload_link}`,
              },
              {
                type: 'text',
                text: `${user_share_review_link}`,
              },
            ],
          },
        ],
      },
    };
    //console.log(data, '----message data----');

    return new Observable((observer) => {
      this.http.post(environment.whtsappCloudUrl, data).subscribe(
        (response) => {
          //console.log('response', response);
          this.http
            .post(`${this.baseUrl}saveFeedback_2`, {
              gfbid: formData.gfbid,
              name: formData.name,
              phone: formData.phone,
              amount: formData.amount,
              nameId: formData.nameId,
              is_verify: 1, //need to update 0 in db
              response: JSON.stringify(response),
              status: 'Success',
            })
            .subscribe((res) => {
              observer.next(response);
              observer.complete();
            });
        },
        (err) => {
          this.http
            .post(`${this.baseUrl}saveFeedback_2`, {
              gfbid: formData.gfbid,
              phone: formData.phone,
              name: formData.name,
              is_verify: 1, //need to update 0 in db
              response: JSON.stringify(err),
              status: 'Failure',
            })
            .subscribe((res) => {
              observer.error(err);
              observer.complete();
            });
        },
      );
    });

    //return this.http.post(this.baseUrl + `sendfeedback`, formData);
  };

  sendSmsFeedback_additional_3 = (
    formData,
    desc,
    review_link,
    image_upload_link,
    user_share_review_link,
  ) => {
    var data = {
      messaging_product: 'whatsapp',
      to: formData.phone,
      type: 'template',
      template: {
        name: 'myvip_2',
        // name: 'myvip_review_',
        language: {
          code: 'en_US',
        },
        components: [
          {
            type: 'body',
            parameters: [
              {
                type: 'text',
                // text: `Review: ${desc}`,
                text: desc,
              },
              {
                type: 'text',
                text: `${review_link}`,
              },
              {
                type: 'text',
                text: `${image_upload_link}`,
              },
              {
                type: 'text',
                text: `${user_share_review_link}`,
              },
            ],
          },
        ],
      },
    };
    //console.log(data, '----message data----');

    return new Observable((observer) => {
      this.http.post(environment.whtsappCloudUrl, data).subscribe(
        (response) => {
          //console.log('response', response);
          this.http
            .post(`${this.baseUrl}saveFeedback_3`, {
              gfbid: formData.gfbid,
              name: formData.name,
              phone: formData.phone,
              amount: formData.amount,
              nameId: formData.nameId,
              is_verify: 1, //need to update 0 in db
              response: JSON.stringify(response),
              status: 'Success',
            })
            .subscribe((res) => {
              observer.next(response);
              observer.complete();
            });
        },
        (err) => {
          this.http
            .post(`${this.baseUrl}saveFeedback_3`, {
              gfbid: formData.gfbid,
              phone: formData.phone,
              name: formData.name,
              is_verify: 1, //need to update 0 in db
              response: JSON.stringify(err),
              status: 'Failure',
            })
            .subscribe((res) => {
              observer.error(err);
              observer.complete();
            });
        },
      );
    });

    //return this.http.post(this.baseUrl + `sendfeedback`, formData);
  };

  getAllVouchers(shopId) {
    return this.http.get(`${this.baseUrl}shop/${shopId}`);
  }

  getActiveVoucher(userId: string, shopId: string) {
    let params = new HttpParams();
    params = params.append('userId', userId);
    params = params.append('shopId', shopId);
    return this.http.get(`${this.baseUrl}/active-vouchers`, { params });
  }

  createVoucher(payload) {
    return this.http.post(`${this.baseUrl}createVoucher`, payload);
  }

  deleteVoucher(id) {
    return this.http.delete(`${this.baseUrl}deleteVoucher/${id}`);
  }
  updateVoucher(payload, id) {
    return this.http.put(`${this.baseUrl}updateVoucher/${id}`, payload);
  }

  redeemVoucher(payload) {
    return this.http.post(`${this.baseUrl}redeem-vouchers`, payload);
  }

  updateSpecialCategory(payload) {
    return this.http.post(
      `${this.baseUrl}update_food_special_category`,
      payload,
    );
  }

  // *** admin-members-analytics ***
  getMembersDetails(): Observable<any> {
    return this.http.get(`${this.baseUrl}userListForMembersAnalytics`);
  }

  disableEnableMember(id: any, status: any): Observable<any> {
    return this.http.post(`${this.baseUrl}disableEnableMember`, {
      id: id,
      status: status,
    });
  }

  submitSuggestionMessage(payload: any, options?: any): Observable<any> {
    return this.http.post(`${this.baseUrl}suggestionMessage`, payload, options);
  }
  suggestionLikes(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}suggestionLikes`, payload);
  }
  suggestionComments(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}suggestionComments`, payload);
  }
  suggestionCommentsGet(payload: any = {}): Observable<any> {
    return this.http.get(
      `${this.baseUrl}suggestionComments?suggestionId=${payload.id}`,
    );
  }
  suggestionCommentsDelete(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}suggestionComments/${id}`);
  }

  getProductRecommendation(payload) {
    return this.http.post(`${this.baseUrl}getProductRecommendation`, payload);
  }

  deleteSuggestion(id: number) {
    return this.http.delete(`${this.baseUrl}suggestion/${id}`);
  }

  pinSuggestion(payload: any) {
    return this.http.post(`${this.baseUrl}suggestionPin`, payload);
  }

  submitReportMessage(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}reportMessage`, payload);
  }
  // *** admin-members-analytics ***

  // *** Super Admin ***
  getAllSuggestions(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllSuggestions`);
  }

  getAllReports(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllReports`);
  }
  // *** Super Admin ***

  // *** Quest Admin ***
  createQuest(
    payload: Array<{ message: string; expireAt: number; userId: number }>,
  ): Observable<any> {
    return this.http.post(`${this.baseUrl}quest/create`, {
      questList: payload,
    });
  }

  getQuestList(): Observable<any> {
    return this.http.get(`${this.baseUrl}quest/get`);
  }

  getUserQuest({ page = 1, limit = 10 }): Observable<any> {
    return this.http.get(`${this.baseUrl}quest/get-user`, {
      params: {
        page,
        limit,
      },
    });
  }

  getUserQuestStats(): Observable<any> {
    return this.http.get(`${this.baseUrl}quest/get-user-stats`);
  }
  // *** Quest Admin ***

  updateQuestStatus(id: number, status: number): Observable<any> {
    let payload = { id: id, status: status };
    return this.http.post(`${this.baseUrl}quest/updateStatus`, payload);
  }
  makeAllNotificationsOfUserSeen() {
    return this.http.put(`${this.baseUrl}makeAllNotificationsOfUserSeen`, {});
  }

  updateNotificationIsRead(id: number): Observable<any> {
    return this.http.post(`${this.baseUrl}updateNotificationIsRead`, {
      id: id,
    });
  }

  saveMemberShopsProfile(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}saveMemberShopsProfile`, payload);
  }

  getAllMemberShopCategory(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberProductCategory`);
  }

  getAllMemberShopSubCategory(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}getMemberProductSubCategory`,
      payload,
    );
  }

  getAllMemberShopProductByLocation(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getMemberProductByLocation`, payload);
  }

  getAllMemberShopProductSearch(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getMemberProductSearch`, payload);
  }

  addMemberProductCategory(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberProductCategory`, payload);
  }

  updateMemberCategoryInfo(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}updateMemberCategoryInfo`, payload);
  }

  addMemberShopKeyword(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}membershop-keywords`, payload);
  }

  updateCategory(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}updateMemberCategory`, payload);
  }

  updateProductCategory(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}updateMemberProductCategory`,
      payload,
    );
  }

  hideMemberShopProduct(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}hideMemberShopProduct`, payload);
  }

  addMemberProductSubCategory(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}addMemberProductSubCategory`,
      payload,
    );
  }

  updateMemberProductSubCategory(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}updateMemberProductSubCategory`,
      payload,
    );
  }

  addShopProduct(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}community/add-shop-product`, payload);
  }

  updateBizReqStatus(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}updateBizReqStatus`, payload);
  }

  editShopProduct(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}community/edit-shop-product`,
      payload,
    );
  }

  getShopProductDetails(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getShopProductDetails`, payload);
  }

  deleteShopProduct(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}deleteShopProduct`, payload);
  }

  deleteShopProductCategory(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}deleteMemberProductCategory`,
      payload,
    );
  }

  deleteShopProductSubCategory(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}deleteMemberProductSubCategory`,
      payload,
    );
  }

  getProfileDetail(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getProfileDetail`, payload);
  }
  getShopDetail(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getShopDetail`, payload);
  }

  userReferralAdd(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}userReferralAdd`, payload);
  }

  userReferralClaim(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}userReferralClaim`, payload);
  }

  userReferralByCode(code: any): Observable<any> {
    return this.http.get(`${this.baseUrl}userReferralByCode/${code}`);
  }

  userReferralUploadFile(code: any): Observable<any> {
    return this.http.get(`${this.baseUrl}userReferralUploadFile/${code}`);
  }
  userReferralUploadFileStore(payload: any, options?: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}userReferralUploadFileStore`,
      payload,
      options,
    );
  }
  userReferralUploadedFile(
    shopId: any = null,
    category: string = 'gallery',
    referralCode: string = null,
  ): Observable<any> {
    return this.http.get(`${this.baseUrl}userReferralUploadedFile`, {
      params: {
        shopId: shopId,
        category: category,
        onlyReferral: referralCode ? '1' : '0',
      },
    });
  }

  getMarketplaceReferralStoreLink(productId) {
    return this.http.get(this.baseUrl + `getMemberStoreLink/${productId}`);
  }

  //Bookings

  addBooking(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addbooking`, payload);
  }

  syncBooking(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}syncbooking`, payload);
  }

  getBookings() {
    return this.http.get(this.baseUrl + `getAllBookings`);
  }

  getBookingById(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getBookingById`, payload);
  }

  updateProfileCharacterDetails(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}updateProfileCharacterDetails`,
      payload,
    );
  }
  //  *** Notification ***

  addProfileCharacter(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addProfileCharacter`, payload);
  }

  getAllProfileCharacter(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllProfileCharacter`);
  }

  deleteProfileCharacter(id: number) {
    return this.http.delete(`${this.baseUrl}deleteProfileCharacter/${id}`);
  }

  addProfileCharacterToMember(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}addProfileCharacterToMember`,
      payload,
    );
  }

  getAllProfileCharacterForMember(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllProfileCharacterForMember`);
  }

  deleteProfileCharacterFromMember(id: number) {
    return this.http.delete(
      `${this.baseUrl}deleteProfileCharacterFromMember/${id}`,
    );
  }

  buyCharacterForMember(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}buyCharacterForMember`, payload);
  }

  buyRoleForMember(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}buyRoleForMember`, payload);
  }

  // Member Template

  public getAllMemberTemplate(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberTemplate`);
  }

  public addMemberTemplate(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberTemplate`, payload);
  }

  public deleteMemberTemplate(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberTemplate/${id}`);
  }

  public getArticlesList(
    page = 1,
    isPopular = 1,
    category,
    pageSize: number,
    withRegion: boolean = false,
  ): Observable<any> {
    const params = {
      isAdmin: false,
      page: page,
      isPopular: isPopular,
      category: category,
      pageSize: pageSize,
      withRegion: withRegion,
    };
    return this.http.get(`${this.baseUrl}get_bottom_banner/0`, { params });
  }
  public getArticlesHashtag(): Observable<any> {
    return this.http.get(this.baseUrl + `get_hashtag_bottom_banner`);
  }

  public assignArticles(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}assignCategoryAndSubRegion`, payload);
  }

  // Member Shop Ads
  addMemberShopAds(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberShopAds`, payload);
  }

  getAllMemberShopAds(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberShopAds`);
  }

  deleteMemberShopAds(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberShopAds/${id}`);
  }

  getMemberShopAdsBy(category: string, subRegion: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}getAllMemberShopAds?category=${category}&subRegion=${subRegion}`,
    );
  }

  // Member Shop Ads

  chatRequestMessage(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}chat/requestMessage`, payload);
  }

  chatGetFiles(payload?: any): Observable<any> {
    return this.http.post(`${this.baseUrl}chat/getFiles`, payload);
  }

  chatUploadFiles(payload?: any): Observable<any> {
    return this.http.post(`${this.baseUrl}chat/uploadFiles`, payload);
  }

  chatDeleteFiles(payload?: any): Observable<any> {
    return this.http.post(`${this.baseUrl}chat/deleteFiles`, payload);
  }

  chatSyncMessage(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}chat/syncMessage`, payload);
  }

  chatAddInstruction(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}chat/addInstruction`, payload);
  }

  chatGetInstruction(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}chat/getInstruction`, payload);
  }

  chatDeleteInstruction(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}chat/deleteInstruction`, payload);
  }

  chatSellerRequest(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}chat/sellerChat`, payload);
  }

  chatCheckChannel(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}chat/checkChatChannel`, payload);
  }

  chatCheckChannelByUrl(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}chat/checkChatChannelByUrl`, payload);
  }

  chatStoreChannel(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}chat/storeChatChannel`, payload);
  }

  chatDeleteChannel(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}chat/deleteChatChannel`, payload);
  }

  chatArchiveChannel(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}chat/archiveChatChannel`, payload);
  }

  chatGetArchiveChannel(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}chat/getArchiveChatChannel`, payload);
  }

  memberShopProductsRecommendBy(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}memberShopProductsRecommendBy`,
      payload,
    );
  }

  getRecommendProductOfUser(type = ''): Observable<any> {
    return this.http.get(
      `${this.baseUrl}getRecommendProductOfUser?type=${type}`,
    );
  }

  deleteMemberShopProductsRecommendBy(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}deleteMemberShopProductsRecommendBy`,
      payload,
    );
  }

  // Member Shop Ask
  addMemberShopAsk(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberShopAsk`, payload);
  }
  likeMemberShopAsk(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}likeMemberShopAsk`, payload);
  }

  getAllMemberShopAsk(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberShopAsk`);
  }

  deleteMemberShopAsk(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberShopAsk/${id}`);
  }

  getMemberAsk(): Observable<any> {
    return this.http.get(`${this.baseUrl}getMemberAsk`);
  }

  // Member Shop Ask

  // Member Page Banner
  addMemberPageBanner(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberPageBanner`, payload);
  }

  getAllMemberPageBanner(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberPageBanner`);
  }

  deleteMemberPageBanner(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberPageBanner/${id}`);
  }
  // Member Page Banner

  // Member Page Categorie
  addMemberCategorieRelationship(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addCategorieRelationship`, payload);
  }

  getAllMemberCategorieRelationship(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllCategorieRelationship`);
  }

  deleteMemberCategorieRelationship(id: number) {
    return this.http.delete(`${this.baseUrl}deleteCategorieRelationship/${id}`);
  }

  getCategoryRelationshipByName(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}getCategoryRelationshipByName`,
      payload,
    );
  }
  // Member Page Categorie

  // Member Events
  addEvents(payload: any, options?: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addEvents`, payload, options);
  }

  getAllEvents(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllEvents`);
  }

  deleteEvents(id: number) {
    return this.http.delete(`${this.baseUrl}deleteEvents/${id}`);
  }

  joinEvent(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}joinEvent`, payload);
  }
  // Member Events

  memberShopOnline(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}memberShopOnline`, payload);
  }

  // Member Shop Certificate

  certificateFetch(): Observable<any> {
    return this.http.get(`${this.baseUrl}certificate/fetch`);
  }

  certificateGet(): Observable<any> {
    return this.http.get(`${this.baseUrl}certificate/get`);
  }

  certificateStore(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}certificate/store`, payload);
  }

  certificateDelete(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}certificate/delete`, payload);
  }

  certificateChangeStatus(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}certificate/changeStatus`, payload);
  }

  public addShopTimer(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addShopTimer`, payload);
  }

  // Member Template Category
  public getAllMemberTemplateCategory(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberTemplateCategory`);
  }

  public addMemberTemplateCategory(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberTemplateCategory`, payload);
  }

  public deleteMemberTemplateCategory(id: number) {
    return this.http.delete(
      `${this.baseUrl}deleteMemberTemplateCategory/${id}`,
    );
  }
  // Member Template Category

  // Member Roles
  public addMemberRole(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberRole`, payload);
  }

  public deleteMemberRole(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberRole/${id}`);
  }

  public getAllMemberRole(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberRole`);
  }

  public addMemberRolePermissionsRelationship(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}addMemberRolePermissionsRelationship`,
      payload,
    );
  }

  public deleteMemberRolePermissionsRelationship(id: number) {
    return this.http.delete(
      `${this.baseUrl}deleteMemberRolePermissionsRelationship/${id}`,
    );
  }

  public addMemberRolePermissions(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberRolePermissions`, payload);
  }

  public deleteMemberRolePermissions(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberRolePermissions/${id}`);
  }

  public getAllMemberRolePermissions(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberRolePermissions`);
  }

  public addMemberLevels(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberLevels`, payload);
  }

  public deleteMemberLevels(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberLevels/${id}`);
  }

  public getAllMemberLevels(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberLevels`);
  }

  public addMemberLevelsRelationship(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}addMemberLevelsRelationship`,
      payload,
    );
  }

  public deleteMemberLevelsRelationship(id: number) {
    return this.http.delete(
      `${this.baseUrl}deleteMemberLevelsRelationship/${id}`,
    );
  }

  public getAllMemberLevelsRelationship(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberLevelsRelationship`);
  }

  public getAllMemberRoleLevel(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberRoleLevel`);
  }

  public updateBulkLevelsToRole(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}updateBulkLevelsToRole`, payload);
  }

  public addMemberUserTypes(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberUserTypes`, payload);
  }

  public deleteMemberUserTypes(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberUserTypes/${id}`);
  }

  public getAllMemberUserTypes(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberUserTypes`);
  }

  public addMemberUserTypeRelationship(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}addMemberUserTypeRelationship`,
      payload,
    );
  }

  public deleteMemberUserTypeRelationship(id: number) {
    return this.http.delete(
      `${this.baseUrl}deleteMemberUserTypeRelationship/${id}`,
    );
  }

  public getAllMemberUserTypeRelationship(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberUserTypeRelationship`);
  }

  public getDefaultUserTypeRoles(): Observable<any> {
    return this.http.get(`${this.baseUrl}getDefaultUserTypeRoles`);
  }

  public addMemberToUserTypes(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberToUserTypes`, payload);
  }

  public deleteMemberToUserTypes(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberToUserTypes/${id}`);
  }

  public getAllUser(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllUser`);
  }

  public addRoleCharacter(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addRoleCharacter`, payload);
  }

  public deleteRoleCharacter(id: number) {
    return this.http.delete(`${this.baseUrl}deleteRoleCharacter/${id}`);
  }

  public getAllRoleCharacter(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllRoleCharacter`);
  }

  // Member Roles

  public updatedMemberShopProductType(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}updatedMemberShopProductType`,
      payload,
    );
  }

  // Member News
  addNews(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addNews`, payload);
  }

  getAllNews(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllNews`);
  }

  deleteNews(id: number) {
    return this.http.delete(`${this.baseUrl}deleteNews/${id}`);
  }
  // Member News

  addNewsDiamond(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addNewsDiamond`, payload);
  }

  deleteNewsDiamond(id: number) {
    return this.http.delete(`${this.baseUrl}deleteNewsDiamond/${id}`);
  }

  addDiamondToReaderAccount(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addDiamondToReaderAccount`, payload);
  }

  signInTestMode(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}signInTestMode`, payload);
  }

  updateStatusOfMemberToUserTypes(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}updateStatusOfMemberToUserTypes`,
      payload,
    );
  }

  // Member Products Attachment
  addProductsAttachment(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addProductsAttachment`, payload);
  }

  getAllProductsAttachment(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllProductsAttachment`);
  }

  deleteProductsAttachment(id: number) {
    return this.http.delete(`${this.baseUrl}deleteProductsAttachment/${id}`);
  }
  // Member Products Attachment

  // Quest
  addQuestLevelsRelationship(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addQuestLevelsRelationship`, payload);
  }

  deleteQuestLevelsRelationship(id: number) {
    return this.http.delete(
      `${this.baseUrl}deleteQuestLevelsRelationship/${id}`,
    );
  }

  getAllQuestLevelsRelationship(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllQuestLevelsRelationship`);
  }

  getAllMemberQuestLevel(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberQuestLevel`);
  }

  updateBulkLevelsToQuest(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}updateBulkLevelsToQuest`, payload);
  }

  addMemberQuest(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberQuest`, payload);
  }

  deleteMemberQuest(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberQuest/${id}`);
  }

  addEmailTemplate(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addEmailTemplate`, payload);
  }

  getAllEmailTemplate(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllEmailTemplate`);
  }

  deleteEmailTemplate(id: number) {
    return this.http.delete(`${this.baseUrl}deleteEmailTemplate/${id}`);
  }

  sendTestMail(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}sendTestMail`, payload);
  }

  sendMail(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}sendMail`, payload);
  }

  getEmailListBaseOnRegion(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getEmailListBaseOnRegion`, payload);
  }

  // Quest

  // Brands
  brands_fetch(): Observable<any> {
    return this.http.get(`${this.baseUrl}brands`);
  }

  brands_add(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}brands`, payload);
  }

  brands_delete(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}brands/${id}`);
  }
  // End Brands

  // Member Survey
  addMemberSurvey(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberSurvey`, payload);
  }
  getAllMemberSurvey(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberSurvey`);
  }
  getAllMemberSurveyWithQuestion(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberSurveyWithQuestion`);
  }
  deleteMemberSurvey(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberSurvey/${id}`);
  }

  addMemberSurveyInterest(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberSurveyInterest`, payload);
  }
  getAllMemberSurveyInterest(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberSurveyInterest`);
  }
  deleteMemberSurveyInterest(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberSurveyInterest/${id}`);
  }

  addMemberSurveyQuestions(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberSurveyQuestions`, payload);
  }
  getAllMemberSurveyQuestions(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberSurveyQuestions`);
  }
  deleteMemberSurveyQuestions(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberSurveyQuestions/${id}`);
  }

  addMemberSurveyQuestionsUserResponses(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}addMemberSurveyQuestionsUserResponses`,
      payload,
    );
  }
  getAllMemberSurveyQuestionsUserResponses(): Observable<any> {
    return this.http.get(
      `${this.baseUrl}getAllMemberSurveyQuestionsUserResponses`,
    );
  }
  deleteMemberSurveyQuestionsUserResponses(id: number) {
    return this.http.delete(
      `${this.baseUrl}deleteMemberSurveyQuestionsUserResponses/${id}`,
    );
  }
  getAllMemberSurveyQuestionsBaseOnSurvey(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}getAllMemberSurveyQuestionsBaseOnSurvey`,
      payload,
    );
  }
  getAllMemberSurveyResponses(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}getAllMemberSurveyResponses`,
      payload,
    );
  }

  addMemberSurveyQuestionAnswerInterestMapping(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}addMemberSurveyQuestionAnswerInterestMapping`,
      payload,
    );
  }
  getAllMemberSurveyQuestionAnswerInterestMapping(): Observable<any> {
    return this.http.get(
      `${this.baseUrl}getAllMemberSurveyQuestionAnswerInterestMapping`,
    );
  }
  deleteMemberSurveyQuestionAnswerInterestMapping(id: number) {
    return this.http.delete(
      `${this.baseUrl}deleteMemberSurveyQuestionAnswerInterestMapping/${id}`,
    );
  }
  // Member Survey

  // Shop Members
  public addShopMembers(payload: any, options?: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addShopMembers`, payload, options);
  }

  public deleteShopMembers(id: number) {
    return this.http.delete(`${this.baseUrl}deleteShopMembers/${id}`);
  }

  public getShopMembers(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}getShopMembers/${id}`);
  }
  // Shop Members

  public addMemberShopSubRegion(payload: any, options?: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}addMemberShopSubRegion`,
      payload,
      options,
    );
  }

  public deleteMemberShopSubRegion(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberShopSubRegion/${id}`);
  }

  public getMemberShopSubRegion(): Observable<any> {
    return this.http.get(`${this.baseUrl}getMemberShopSubRegion`);
  }

  public addMemberShopRegion(payload: any, options?: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}addMemberShopRegion`,
      payload,
      options,
    );
  }

  public deleteMemberShopRegion(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberShopRegion/${id}`);
  }

  public getMemberShopRegion(): Observable<any> {
    return this.http.get(`${this.baseUrl}getMemberShopRegion`);
  }

  public addRegionMapping(payload: any, options?: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addRegionMapping`, payload, options);
  }

  public deleteRegionMapping(id: number) {
    return this.http.delete(`${this.baseUrl}deleteRegionMapping/${id}`);
  }

  public getRegionMapping(): Observable<any> {
    return this.http.get(`${this.baseUrl}getRegionMapping`);
  }

  public updateMemberShopProductSubRegionId(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}updateMemberShopProductSubRegionId`,
      payload,
    );
  }

  public getActivityLog(page: number): Observable<any> {
    return this.http.get(`${this.baseUrl}activityLog?page=${page}`);
  }

  // Tag
  public addCategorieTag(payload: any, options?: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addCategorieTag`, payload, options);
  }

  public deleteCategorieTag(id: number) {
    return this.http.delete(`${this.baseUrl}deleteCategorieTag/${id}`);
  }

  public getAllCategorieTag(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllCategorieTag`);
  }
  // Tag

  //FaqSection
  public addFaqSection(payload: any, options?: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addFaqSection`, payload, options);
  }

  public deleteFaqSection(id: number) {
    return this.http.delete(`${this.baseUrl}deleteFaqSection/${id}`);
  }

  public getAllFaqSection(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllFaqSection`);
  }

  public addFaqQuestion(payload: any, options?: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addFaqQuestion`, payload, options);
  }

  public deleteFaqQuestion(id: number) {
    return this.http.delete(`${this.baseUrl}deleteFaqQuestion/${id}`);
  }

  public getAllFaqQuestionBySection(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllFaqQuestionBySection/${id}`);
  }
  //FaqSection

  public getAllMemberJobPost(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberJobPost`);
  }

  public add_image_cat(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}add_image_cat`, payload);
  }

  public getAllRentProdut(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllRentProdut`);
  }

  public addRentProducts(payload: any, options?: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addRentProdut`, payload, options);
  }

  public deleteRentProdut(id: number) {
    return this.http.delete(`${this.baseUrl}deleteRentProdut/${id}`);
  }

  public getUsersStatistics(): Observable<any> {
    return this.http.get(`${this.baseUrl}getUsersStatistics`);
  }

  public uploadEmailImages(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}uploadEmailImages`, payload);
  }

  public getShoutOutProducts(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}community/shout-out-products`, {
      params: payload,
    });
  }

  public assignProductReview(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}assign_product_review`, payload);
  }
}
